{
  "heroic_approval": {
    "karma": "Trust",
    "setting_hint": "Shows your credited experience points and trust when a good deed is confirmed."
  },
  "category_milestones": {
    "description": "Earn category experience points, unlock titles and badges, and choose one title for your profile."
  },
  "level_up": {
    "setting": "Show personal level-up popups"
  },
  "profile_identity": {
    "subtitle": "Your profile"
  },
  "adventureFlow": {
    "intro": "Your contribution counts. Real good deeds become an engagement that helps you and your community grow."
  },
  "flyers": {
    "adventurer": {
      "title": "Your engagement at a glance",
      "body": "Good deeds, experience, groups and real benefits: the member flyer shows you how Goodvale works. Download it and share it with friends.",
      "alt": "Preview of the Goodvale member flyer"
    }
  },
  "partnersPage": {
    "intro": "Goodvale turns good deeds into an engagement: people help their communities, earn experience and rise through the engagement tiers. Your business rewards that commitment with offers that give new customers a reason to discover you.",
    "example": "Example: your café offers 10% off from engagement tier E, once per person per week.",
    "steps": [
      {
        "title": "Help & discover",
        "body": "Lea does good, reaches engagement tier E and discovers your café and its offer in Goodvale."
      },
      {
        "title": "QR pass or digital",
        "body": "Lea presents her QR pass to be scanned. For a digital offer, she redeems it in the app and uses the provided code. Goodvale checks eligibility and limits."
      },
      {
        "title": "Enjoy the benefit",
        "body": "Your team confirms the on-site redemption and applies the discount at checkout: €10 becomes €9. The redemption is recorded."
      }
    ]
  },
  "class_change": {
    "current": "Your current focus",
    "preview": "Your new focus",
    "preview_hint": "Choose a focus icon to explore its abilities and bonuses.",
    "xp_safe": "Your existing experience points stays with you",
    "title": "Change focus",
    "explanation": "You can change your focus once within seven days of registration. Your existing experience points and levels stay unchanged. Ongoing good deeds keep their saved bonuses.",
    "choose": "Select a new focus",
    "confirm": "Choose this focus permanently? You cannot change your focus again afterwards. Your existing experience points will stay unchanged.",
    "save": "Use one-time focus change",
    "success": "Your focus has changed. Your existing experience points is preserved.",
    "error": "Your focus could not be changed.",
    "load_error": "Focus Areas could not be loaded.",
    "used": "You have already used your one-time focus change.",
    "unavailable": "Focus changes are unavailable. You can only change focus during your first seven days."
  },
  "ui_text": {
    "admin_dashboard": {
      "intro": "Aggregated live information on moderation, partner applications, groups, users, and audit logs.",
      "guilds_stat": "Groups",
      "active_guilds": "Active groups in the game",
      "no_pending_deeds": "No good deeds are pending community review review.",
      "recent_users_intro": "Recently registered members and profiles",
      "guilds_and_foundings": "Groups & foundings",
      "guilds_intro": "Group overview and Group points points",
      "all_guilds": "All groups",
      "no_guilds": "No groups have been founded yet."
    },
    "admin_class_category": {
      "title": "Focus & Category Configurator",
      "intro": "Configure member focus areas, perks, good deed categories, and partner categories, including soft deletion.",
      "loading_classes": "Loading focus areas & perks...",
      "no_classes": "No focus areas available.",
      "general_xp_bonus": "General good deed experience points bonus",
      "cooldown_reduction": "Good deed waiting time reduction"
    },
    "partner_offer_editor": {
      "map_intro": "Click the map or choose a quick option to set the location for members.",
      "guild_category": "Group category",
      "max_per_adventurer": "Max. redemptions per member (optional)"
    },
    "guild_members_admin": {
      "banned_adventurers": "Banned members",
      "loading_bans": "Loading banned members...",
      "no_bans": "No active group bans",
      "ban_adventurer": "Ban member from group",
      "ban_warning": "The member will be removed from the group immediately, and future join reprojects will be permanently blocked.",
      "ban_reason": "Reason for the group (optional):"
    },
    "guild_branding": {
      "loading": "Loading group branding...",
      "emblem_intro": "Design your group emblem with a symbol, frame, wings, crest, base, and color scheme.",
      "details_title": "Group details & public profile",
      "details_intro": "This information is visible to all members on the group home page and overview.",
      "motto": "Group motto & philosophy / description:",
      "location": "Group location (coordinates): *"
    },
    "guild_detail_misc": {
      "back_to_guilds": "Back to group overview",
      "ban_confirm": "Do you really want to permanently ban this member from the group?",
      "sole_leader_warning": "You are the only group leader. Appoint another member as a group leader before leaving the group."
    },
    "admin_tribunal_moderators": {
      "applications_intro": "New applications from members of Engagement Tier C or higher appear here for approval or rejection."
    },
    "heroic_actions_misc": {
      "rules_slots_timing": "For individual actions, the waiting time starts when experience points is awarded. For group actions, it runs from registration and does not restart when experience points is awarded. “My slots” shows your current occupancy and remaining cooldowns."
    },
    "admin_heroic_actions": {
      "rank_f": "Engagement Tier F (Novice)",
      "rank_e": "Engagement Tier E (Explorer)",
      "rank_d": "Engagement Tier D (Pioneer)",
      "rank_c": "Engagement Tier C (Guardian)",
      "rank_b": "Engagement Tier B (Master)",
      "rank_a": "Engagement Tier A (Elite)",
      "rank_s": "Engagement Tier S (Legend)"
    },
    "game_mechanics_misc": {
      "view_classes_ranks": "View focus areas"
    },
    "guilds_misc": {
      "no_guild_intro": "You are not in a group yet. Create your own group or join a community!"
    }
  },
  "guild_rooms": {
    "hall": "Group hall",
    "treasury": "Points Account",
    "shop": "Group shop",
    "navigation": "Group navigation"
  },
  "hero_card": {
    "title": "Member card",
    "karma": "Trust",
    "guild": "Group",
    "qr": "Current member pass"
  },
  "dialogs": {
    "moderator_title": "Join the community review"
  },
  "app": {
    "adventurer": "Member {{name}}",
    "rank_class": "Engagement Tier {{rank}} • {{class}}"
  },
  "world": {
    "nav": {
      "guild": "Group"
    }
  },
  "common": {
    "adventurer": "Member",
    "rank": "Engagement Tier {{rank}}"
  },
  "nav": {
    "dashboard": "Member ID",
    "talents": "Benefits",
    "tavern": "News",
    "guilds": "Groups",
    "classes_ranks": "Focus Areas & Engagement Tiers",
    "classes": "Focus Areas",
    "ranks": "Engagement",
    "world_guild_mgmt": "Group Management",
    "good_deeds": "Deeds & EP"
  },
  "karma": {
    "title": "Trust · Trust",
    "subtitle": "Your code of conduct and standing in the World Group.",
    "points": "{{score}} Trust Points",
    "open_barometer": "Open the trust bar in the profile",
    "markers_title": "Trust thresholds and requirements",
    "marker_guild": "Found a group",
    "marker_guild_detail": "Minimum trust; engagement tier and approved deeds are also required.",
    "marker_tribunal": "Community Review application",
    "marker_tribunal_detail": "Minimum trust; Engagement Tier {{rank}} is also required.",
    "marker_neutral_detail": "No trust sanction.",
    "marker_partner_detail": "Applies from {{partner}} to {{minimum}} trust.",
    "marker_xp": "Daily experience points deduction",
    "marker_xp_detail": "Applies from {{xp}} to {{xpEnd}}; {{percent}}% of total experience points daily.",
    "marker_tribunal_loss": "Community Review rights revoked",
    "marker_tribunal_loss_detail": "At {{tribunalLoss}}, an existing Community Review role is removed.",
    "tier_trusty_desc": "Positive trust from regular, verified good deeds.",
    "tier_neutral_desc": "Balanced trust. Submit good deeds or support your group.",
    "tier_warned_desc": "From {{partner}} trust, partner benefits are blocked. Verified good deeds rebuild trust.",
    "tier_outlaw": "Daily experience points deduction",
    "tier_outlaw_desc": "From {{xp}} to {{xpEnd}} trust, {{percent}}% of your current total experience points is deducted daily.",
    "tier_banned_desc": "Your account has been suspended separately, independently of trust.",
    "rules": "Trust ranges from {{minimum}} to {{maximum}}. At {{partner}} partner benefits are blocked, from {{xp}} {{percent}}% of total experience points is deducted daily, and at {{suspension}} the account is suspended for {{months}} calendar month(s).",
    "tier_restricted_desc": "From {{suspension}} to {{minimum}} trust, your account is suspended for {{months}} calendar month(s). A separate admin suspension is unaffected.",
    "tier_released_desc": "The temporary account suspension has ended. Partner benefits remain blocked at this trust score.",
    "moderate": "Manage trust",
    "moderation_hint": "Group admin deductions require system admin approval. After approval, the affected person sees your reason and name.",
    "deduction": "Trust deduction (1–100 points)",
    "submit": "Deduct trust & notify",
    "saved": "Trust deduction saved and notification created.",
    "pending_saved": "Trust deduction sent to a system admin for approval.",
    "pending_title": "Pending trust deductions",
    "pending_notification": "{{actor}} requested a {{points}} trust deduction for {{target}}.",
    "history": "Trust · Explained deductions",
    "no_penalties": "No trust deductions.",
    "scope": "Group admins can manage members of their own group. Superadmins can act across groups.",
    "penalty_notification_title": "Your trust has changed",
    "penalty_notification": "{{actor}} adjusted your trust by {{delta}} points. New score: {{score}}. Reason: {{reason}}"
  },
  "tavern": {
    "detail": {
      "back": "Back to the news",
      "footer": "News from Goodvale"
    },
    "feed": {
      "adventurer": "Member: {{name}}",
      "guild": "Group: {{name}}",
      "xpEarned": "+{{xp}} experience points earned",
      "adventurerJoinedTag": "NEW MEMBER"
    },
    "title": "News",
    "empty": "It's quiet in the news today.",
    "rank": "Engagement Tier {{rank}}"
  },
  "guilds": {
    "decorations": {
      "title": "Unlocked group decorations"
    },
    "createModal": {
      "title": "Found a New Group",
      "namePlaceholder": "Group name (max. 60 characters)",
      "descPlaceholder": "Group philosophy / description (optional, max. 300 characters)",
      "submit": "Found Group",
      "nameRequired": "A group name is required.",
      "nameTooLong": "Group name may be at most 60 characters.",
      "locationTitle": "Group location",
      "creating": "Creating group…"
    },
    "createPage": {
      "basicInfoTitle": "1. Group Details",
      "requirementsTitle": "Requirements to found a group",
      "requirements": "At least engagement tier {{rank}}, {{actions}} approved good deeds and {{karma}} trust. You must not already belong to a group. After dissolving or transferring leadership of your group, wait {{days}} days before founding another.",
      "requirementsIntro": "To found a group, you need:",
      "rankProgress": "Engagement Tier {{required}} (current: {{current}})",
      "karmaProgress": "{{required}} trust (current: {{current}})",
      "cooldownUntil": "Leadership waiting time until {{date}}",
      "cooldownReady": "{{days}} day waiting time after dissolving or transferring your group",
      "noGuildRequirement": "You must not already belong to another group.",
      "requirementsUnavailable": "Group founding requirements could not be loaded. Please try again later.",
      "requirementsLoading": "Loading group founding requirements…",
      "forgeHint": "After founding your group, you can unlock more emblem designs and colors in the group shop's Logo Editor with Group points.",
      "description": "Choose your new group’s name, purpose, logo and location on the map."
    },
    "title": "Group Center",
    "subtitle": "Find a group or create your own.",
    "description": "Find a community that suits you. Discover groups and make a difference together through good deeds.",
    "directory_title": "Group Directory",
    "directory_intro": "Discover other groups and join a community.",
    "founding_title": "Found your own group",
    "clear_search": "Clear group search",
    "pagination_label": "Group directory pages",
    "empty": "No groups available yet.",
    "loadError": "Failed to load groups.",
    "create": "Create Group",
    "yourGuild": "Your Group",
    "yourGuildAdmin": "Your Group (Admin)",
    "inOtherGuild": "In Other Group",
    "back_to_guilds": "All groups",
    "backToGuilds": "Back to group directory",
    "ausgew_hltes_gildenw": "Selected group emblem",
    "gildenhaus": "Group hall",
    "entdecke_andere_gild": "Discover other groups and join a community.",
    "du_bist_aktuell_in_k": "You are currently not in a group. Start your own group or join a community!",
    "gilde_suchen_placeholder": "Search group...",
    "enterGuildhouse": "Open group overview",
    "memberBanner": {
      "memberSubtitle": "Visit your group or discover other communities near you."
    },
    "house_status": "Group status"
  },
  "share": {
    "subtitle": "Invite other members to join the group and explore the world!"
  },
  "pos": {
    "subtitle": "Scan member passes, verify signatures, and evaluate on-site discounts in real time.",
    "standby_desc": "Hold an member’s QR pass in front of the camera or enter the QR code manually.",
    "title": "Partner POS & QR Verification"
  },
  "profile_v2": {
    "progress_line": "Engagement Tier {{rank}} · Level {{level}} · {{xp}} experience points",
    "preferences": "Appearance & language",
    "moderator_title": "Become a Community Review Moderator",
    "moderator_help": "From Engagement Tier {{rank}} and {{karma}} trust, you can apply. Independent reviews are assigned only after admin approval.",
    "delete_confirm": "Do you really want to permanently anonymize your account? Evidence files and contact details will be deleted. If you are the last member of your group, the group will also be permanently deleted."
  },
  "map_v2": {
    "guilds": "Groups"
  },
  "chats_v2": {
    "permission_guild": "People in my group",
    "subtitle": "Private conversations between members. Group coordination belongs in group chat.",
    "search": "Search members …",
    "rank": "Engagement Tier {{rank}}",
    "rank_class": "Engagement Tier {{rank}} · {{heroClass}}"
  },
  "game_mechanics": {
    "groups": {
      "text": "Group admins may announce voluntary, non-commercial group good deeds. Members register and confirm participation after the activity begins. The organizer allocates total experience points among confirmed participants, with no more than 50% per person. The community review reviews the allocation. Partners may not turn these activities into concealed commercial work."
    },
    "removed": {
      "text": "There is no purchasable or transferable in-game currency. Progress is earned exclusively through approved good deeds and can neither be bought nor transferred between people. Groups and partners do not issue paid assignments and receive no share of your experience. There are also no shortcuts for ranking up or tax-like game mechanics."
    },
    "ai_abuse": {
      "text": "Goodvale is built on genuine real-world actions and mutual trust. Misusing AI to generate, fabricate, or manipulate good deeds and evidence is strictly prohibited. Any detected AI abuse will be punished with negative trust and, if necessary, an account ban."
    },
    "karma": {
      "neutral": {
        "title": "No trust sanction"
      },
      "xp": {
        "title": "Additional daily experience points deduction",
        "text": "Once per UTC day, {{percent}}% of current total experience points is deducted. The percentage can be changed in system settings. Category experience points stays intact; level and engagement tier are recalculated."
      },
      "tribunal": {
        "title": "Community Review rights revoked",
        "text": "At {{tribunalLoss}} trust, an existing Community Review role is removed and a pending application is reset. Recovery requires a new application. Engagement Tier {{tribunalRank}} and at least {{tribunalMinimum}} trust are required; both values are configurable."
      },
      "suspension": {
        "text": "The account is suspended for {{months}} calendar month(s). No daily experience points is deducted during that time. This trust suspension then ends automatically."
      },
      "title": "Trust in detail",
      "intro": "Trust starts at 0 and ranges from {{minimum}} to {{maximum}}. Approved good deeds raise it; a rejected or withdrawn deed alone does not lower it. Admins can deduct trust for misconduct with a stated reason.",
      "note": "The daily deduction rounds up to whole experience points, stops at 0 experience points, and appears in the experience points ledger. After the suspension ends, trust below the partner threshold still blocks partner benefits. A separate admin suspension ends only when manually lifted. Approved good deeds can rebuild trust."
    },
    "subtitle": "Submit good deeds, have them independently reviewed, earn experience points, and unlock matching partner offers.",
    "flow": [
      {
        "title": "1. Good deed",
        "description": "Describe a completed voluntary good deed and submit only the privacy-conscious evidence that is needed."
      },
      {
        "title": "2. Community Review",
        "description": "The first review sets time and effort, planning and coordination, and experience points. The experience points amount determines whether one, two, or three independent reviews and an additional admin review are required."
      },
      {
        "title": "3. Progress",
        "description": "Only the final approval writes global and category experience points to the immutable experience points ledger. Level, engagement tier, and category level are calculated from it."
      },
      {
        "title": "4. Partners",
        "description": "Offers may require engagement tier, level, global experience points, category experience points, or an approved system good deed. Redemption uses a short-lived, signed, one-time QR pass."
      }
    ],
    "gildex": {
      "title": "Group points and points account",
      "text": "When a good deed is approved, the group recorded at submission additionally receives a configurable share of base experience points as Group points. Player experience points are not reduced. Group points have no monetary value, cannot be purchased, cashed out or transferred, and are not accepted by partners. Group admins may use them only for internal decorations and convenience features."
    },
    "perks": {
      "title": "Focus Areas and benefits",
      "items": [
        {
          "title": "More experience",
          "description": "Some focus areas and benefits award extra experience points after your good deed is approved."
        },
        {
          "title": "More at once",
          "description": "Extra slots let you work on several good deeds or group actions at the same time."
        },
        {
          "title": "Shorter wait",
          "description": "Certain abilities reduce the wait until your next submission."
        },
        {
          "title": "Achieve more together",
          "description": "A Leisure & Connection raises experience points for an approved group action by 10%. The bonus applies only once, even with several Bards."
        },
        {
          "title": "Category progress",
          "description": "Category experience points helps you progress in the matching area. Your total experience points is tracked separately."
        },
        {
          "title": "Improve trust",
          "description": "Some benefits increase your trust after approved good deeds. Evidence review remains independent."
        },
        {
          "title": "Experience Bonus",
          "description": "With the Food & Nutrition focus, you can activate one free experience bonus per calendar week before an individual action. The configured bonus applies to total and category experience points."
        }
      ]
    },
    "principles_title": "Principles & Group Dynamics",
    "classes_link": "View all 10 focus areas",
    "start_description": "Choose your focus, document your first voluntary contribution, and earn verified experience."
  },
  "player_progress": {
    "xp_value": "{{xp}} EP",
    "next_level_xp": "To next level: {{xp}} experience points",
    "next_level_xp_short": "{{xp}} EP left"
  },
  "level_statistics": {
    "subtitle": "Level {{level}} · {{xp}} experience points in total. Track your progress and the approved good deeds that earned your experience.",
    "xp_to_talent": "experience points to next benefit point",
    "talent_point_ready": "Benefit point available",
    "talent_points_max": "All benefit points earned",
    "xp": "experience points",
    "monthly_xp": "experience points this month",
    "zero": "0 experience points",
    "no_history": "There has been no experience points gain in the last twelve months yet.",
    "deeds_title": "Good deeds & EP earned",
    "no_deeds": "There are no approved good deeds with experience points yet."
  },
  "slotsPage": {
    "cooldownFrom": "Waiting time from:",
    "skipSuccess": "Waiting time skipped. The slot is now free.",
    "skipError": "The waiting time could not be skipped.",
    "cooldown": "Waiting time",
    "groupCooldown": "Group waiting time"
  },
  "dashboard_v2": {
    "adventurer_kicker": "Goodvale · Member",
    "free_adventurer": "Independent member",
    "hero_class": "Focus",
    "class": "Focus",
    "class_category_bonus": "Focus bonus +{{percent}}% EP",
    "other_category_bonus": "+{{percent}}% category EP",
    "next_talent_point": "Next benefit point: Lv. {{level}}",
    "talent_stage": "Engagement Tier {{rank}}",
    "no_talents": "No benefits unlocked yet",
    "reset_banner": "Restore focus artwork",
    "talents_panel_title": "Your benefits",
    "available_talent_points": "Available benefit points",
    "open_talent_tree": "Open benefit paths",
    "class_panel_title": "Focus & specialization",
    "open_class_progress": "Open focus and engagement tier progress",
    "eyebrow": "Member Hub",
    "subtitle": "Submit good deeds, follow community review decisions, and grow your character and category progress.",
    "go_to_guild": "Go to My Group",
    "no_guild": "Not yet in a group",
    "browse_guilds": "View Groups",
    "open_tribunal": "Open Community Review",
    "total_xp": "Total experience points",
    "rank": "Engagement tier",
    "class_and_rank": "{{heroClass}} · Engagement Tier {{rank}}",
    "xp_value": "{{xp}} experience points",
    "karma": "Trust",
    "apply_moderator_help": "From Engagement Tier C, you can apply to conduct independent community review reviews.",
    "moderator_prompt": "Why would you like to become a community review moderator?",
    "status_PendingReview": "Community Review Review"
  },
  "partner_offers": {
    "redemption_channel_help": "Choose where and how members can redeem your offer.",
    "freq_once_ever": "Once per member",
    "subtitle": "Choose which verified progress unlocks an offer. experience points are not spent on redemption.",
    "empty_desc": "Create your first partner offer with a engagement tier, experience points, category, or heroic-action requirement.",
    "modal_subtitle": "Automatically evaluated at POS when scanning members.",
    "req_karma": "Min. Trust: {{karma}}",
    "responsibility_confirmation": "I confirm that I am responsible for this offer's content, availability, and fulfillment. experience points are not consumed, transferable, or worth money.",
    "form_rank": "Minimum Engagement Tier",
    "form_global_xp": "Total experience points",
    "form_category_xp": "Category experience points",
    "form_honor": "Minimum Trust",
    "req_rank": "Engagement Tier {{rank}} or higher",
    "req_global_xp": "{{xp}} Total experience points",
    "req_category_xp": "{{xp}} experience points in {{category}}",
    "category_required": "Select a category for the category-level or experience points requirement."
  },
  "errors": {
    "medic_notice": " (incl. Supporter bonus +1 engagement tier)",
    "merchant_notice": " (incl. Special / Benefit bonus)"
  },
  "error": {
    "desc": "An unexpected error occurred. Our Community Review has been notified automatically."
  },
  "register": {
    "field_contact": "Contact for members",
    "field_contact_hint": "How members can reach you (for example, phone, email or website).",
    "field_contact_required": "Please provide a contact for members.",
    "role_adventurer": "Member",
    "class": "Focus",
    "class_required": "Please select a focus.",
    "class_title": "Choose your Focus",
    "classesSubtitle": "Ten focus areas, one common goal: making real good deeds visible.",
    "class_hint": "Each focus gains +20% global and category experience points for approved actions in its category and a special focus ability.",
    "class_hint_bold": "You can change your focus once in your profile within the first seven days after registration. After that, your choice is final. Previously awarded experience points stays unchanged.",
    "field_category_note": "Important for the member focus trigger system.",
    "class_scout": "Companion",
    "class_medic": "Supporter",
    "class_social": "Creator",
    "class_tank": "Athlete",
    "class_environment": "Nature Lover",
    "class_tech": "Researcher",
    "class_crafter": "Maker",
    "class_nutrition": "Provider",
    "class_logistics": "Organizer",
    "class_guardian": "Caretaker",
    "classes_loading": "Loading focus abilities …",
    "classes_error": "Could not load focus abilities. Please try again."
  },
  "login": {
    "subtitle": "Login for Members and Partners"
  },
  "public_profile": {
    "bio_title": "About this Member",
    "no_bio": "This member has not set a public bio yet.",
    "karma_score": "Trust Score",
    "rank": "Engagement Tier {{rank}}",
    "visitor_title": "Member profile"
  },
  "location_picker": {
    "hint": "Click the location of your business or group. This location will be publicly visible on the world map."
  },
  "admin_partners": {
    "nav_title": "Partners & Reprojects",
    "title": "Partners & Partner Reprojects",
    "loading": "Loading partner reprojects …",
    "empty": "No pending partner reprojects."
  },
  "admin_nav": {
    "tribunal_moderators": "Community Review Moderators",
    "karma": "Trust Management",
    "class_categories": "Focus Areas, Perks & Categories",
    "heroic_actions": "Community Review",
    "xp_audits": "experience points review",
    "guild_hall": "Group Overview Editor"
  },
  "xp_audit": {
    "title": "experience points alerts",
    "intro": "Review experience points earned quickly. Held rewards do not affect engagement tier or progress until a decision is made.",
    "recent_awards": "Recent experience points entries",
    "player_pending": "experience points held for admin review",
    "approve": "Release experience points",
    "reject": "Reject experience points",
    "load_error": "Could not load experience points review cases."
  },
  "admin_tribunal_moderators": {
    "title": "Community Review Moderators & Applications",
    "subtitle": "Review open applications from members from Engagement Tier C and manage active community review moderation permissions.",
    "no_moderators": "No community review moderators are currently active.",
    "revoke_confirm_text": "Are you sure you want to revoke community review moderation permissions for {{name}}? They will no longer be able to review good deeds."
  },
  "admin_karma": {
    "pending_empty": "No pending reprojects.",
    "deduct_error": "Failed to deduct trust.",
    "award_error": "Failed to award trust.",
    "unknown_user": "Member",
    "pending_title": "Reprojects from group admins",
    "title": "Trust Management",
    "scope_hint": "Superadmins can manage trust for all accounts, deduct or award points, and review full audit history.",
    "filter_restricted": "experience points deduction or suspension (≤ {{xp}})",
    "manage_btn": "Manage Trust",
    "current_score": "Current Trust Score",
    "tier_xp_penalty": "Daily experience points deduction",
    "tab_deduct": "Deduct Trust (Penalty)",
    "tab_award": "Award Trust (Bonus)",
    "tab_history": "Trust History",
    "deduct_desc": "Decreases the user's trust. Required justification is logged in audit log and sent via notification.",
    "award_desc": "Increases the user's trust for exceptional merit or adjustments.",
    "submit_deduct": "Deduct Trust & Notify User",
    "submit_award": "Award Trust & Notify User",
    "deduct_success": "Trust deduction saved successfully ({{delta}} points).",
    "award_success": "Trust award saved successfully (+{{delta}} points).",
    "history_empty": "No trust records found for this user.",
    "history_title": "Audit Log & Trust Changes",
    "rules_summary_title": "Trust System Rules",
    "rules_threshold": "At {{partner}} partner block; {{xp}} to {{xpEnd}} {{percent}}% experience points deducted daily; at {{tribunal}} Community Review rights revoked; at {{suspension}} account suspended for {{months}} calendar month(s)",
    "rules_recovery": "Verified good deeds gradually rebuild trust"
  },
  "admin_settings": {
    "filter_heroic_actions": "Good Deeds & experience points Ranges",
    "filter_progression": "Engagement Tiers & Progression"
  },
  "admin_events": {
    "form_ep_multi": "experience points Multiplier",
    "multiplier_hint": "1 = no experience points bonus, 1.5 = +50% experience points, 2 = double experience points.",
    "rewards_hint": "Additional event trust (0–100). The actual reward is awarded when the submitted action is reviewed.",
    "global_impact_desc": "Events temporarily override system multipliers for all players worldwide. They are the most powerful tool of the Group Master to steer volunteers towards specific sectors."
  },
  "access": {
    "unauthorized_back_dashboard": "Back to Member Dashboard",
    "role_adventurer": "Member",
    "role_guildadmin": "Group Leader"
  },
  "nav_cross": {
    "goto_adventurer_dashboard": "Go to Member Dashboard",
    "tooltip_dual_role": "You are also an Member"
  },
  "guild": {
    "public_about": "About our group",
    "public_navigation": "Explore the group",
    "already_in_guild_hint": "You can only belong to one group. Leave your current group first.",
    "leave": "Leave group",
    "leave_confirm": "Are you sure you want to leave this group?",
    "disband_confirm": "You are the last member of {{name}}. Leaving will permanently delete the group. Do you want to disband it?",
    "successor_warning": "Choose a member to take over group leadership before you leave. The group will remain active.",
    "leave_error": "Could not leave group.",
    "own_house": "Your group overview",
    "public_house": "Public group overview",
    "detail_description": "Your shared good deeds leave their mark. As your group renown grows, your hall becomes more magnificent.",
    "tab_news": "Group News",
    "tab_stammtisch": "Group Common Table",
    "gildex_treasury": "Group Points Account",
    "unlocked_emotes": "Group Emotes",
    "news_title": "Group News & Announcements",
    "news_subtitle": "Official system messages and administrative announcements for all group members.",
    "news_editor_title": "Write a group announcement",
    "news_title_placeholder": "e.g. Next group meeting and good deed focus …",
    "news_content_placeholder": "Share all important information with your group members …",
    "news_publish_success": "Announcement published in group news.",
    "news_loading": "Loading group news …",
    "news_system_author": "System · Group Headquarters",
    "no_news_desc": "Group admins can publish official announcements here.",
    "stammtisch_title": "Group Common Table",
    "chat_empty_description": "Welcome your group members or talk about your engagements.",
    "chat_rank": "Engagement Tier {{rank}}",
    "chat_poll_question": "Ask your group a question",
    "chat_action_failed": "Could not update group chat.",
    "more_emotes_hint": "Common Table Plus in Group Shop",
    "emote_cat_guild": "Group",
    "emote_cat_tavern": "News",
    "admins_title": "Group Admins:",
    "leader_title": "Group Leader:",
    "admin_badge": "Group Leader",
    "promote_admin_title": "Promote to Group Leader",
    "promote_confirm": "Do you want to promote \"{{name}}\" to Group Leader?",
    "promote_success": "\"{{name}}\" has been successfully promoted to Group Leader."
  },
  "notifications": {
    "heroic_action": {
      "approved_message": "Your good deed ‘{{title}}’ was approved. +{{xp}} experience points.",
      "review_assigned_title": "New community review review",
      "appeal_approved_message": "The good deed will be reviewed in a new, independent community review round."
    },
    "group_action": {
      "invited_message": "Your group leader invited you to {{title}}. Open your group's group good deeds to register voluntarily.",
      "announced_message": "Your group announced ‘{{title}}’. Registration is open.",
      "approved_message": "‘{{title}}’ was approved. Your share: +{{xp}} experience points."
    },
    "xp_audit": {
      "pending_title": "experience points under review",
      "pending_message": "‘{{title}}’ was approved. experience points is held for admin review because of rapid experience points gains.",
      "released_title": "experience points released",
      "released_message": "Admin review is complete. +{{xp}} experience points has been credited.",
      "rejected_title": "experience points not released",
      "rejected_message": "Admin review did not release {{xp}} held experience points."
    },
    "guild_app_approved": {
      "title": "Group Join Approved!",
      "message": "Congratulations! Your join request for the group '{{guildName}}' was accepted."
    },
    "guild_app_denied": {
      "title": "Group Join Rejected",
      "message": "Your join request for the group '{{guildName}}' was unfortunately rejected."
    },
    "promotion": {
      "title": "Promoted to Group Leader!",
      "message": "Congratulations! You have been promoted to Group Leader."
    }
  },
  "talents": {
    "branches": {
      "A": {
        "subtitle": "Shorter waits, more submissions, and Group points"
      },
      "B": {
        "subtitle": "More total experience points, category experience points, and trust"
      },
      "C": {
        "subtitle": "Strengthen trust and group actions"
      }
    },
    "skills": {
      "A_HEROIC_ACTION_SPONSOR": {
        "title": "Group Patron",
        "rank1_value": "+10% Group points",
        "rank2_value": "+20% Group points",
        "rank3_value": "+30% Group points",
        "rank1": "Stage 1: Your approved good deeds give your group 10% more Group points.",
        "rank2": "Stage 2: Your approved good deeds give your group 20% more Group points.",
        "rank3": "Stage 3: Your approved good deeds give your group 30% more Group points."
      },
      "B_TREASURE_HUNTER": {
        "rank1_value": "+5% total experience points",
        "rank2_value": "+10% total experience points",
        "rank3_value": "+15% total experience points",
        "rank1": "Stage 1: You earn 5% more total experience points from approved good deeds.",
        "rank2": "Stage 2: You earn 10% more total experience points from approved good deeds.",
        "rank3": "Stage 3: You earn 15% more total experience points from approved good deeds."
      },
      "B_BARTERER": {
        "rank1_value": "+5% category experience points",
        "rank2_value": "+10% category experience points",
        "rank3_value": "+15% category experience points",
        "rank1": "Stage 1: You earn 5% more category experience points from approved good deeds.",
        "rank2": "Stage 2: You earn 10% more category experience points from approved good deeds.",
        "rank3": "Stage 3: You earn 15% more category experience points from approved good deeds."
      },
      "B_VERIFIED_PROOF": {
        "rank1_value": "+1 trust",
        "rank2_value": "+2 trust",
        "rank3_value": "+3 trust",
        "rank1": "Stage 1: An approved good deed gives you 1 additional trust point.",
        "rank2": "Stage 2: An approved good deed gives you 2 additional trust points.",
        "rank3": "Stage 3: An approved good deed gives you 3 additional trust points."
      },
      "C_RESILIENCE": {
        "rank1_value": "up to +1 trust",
        "rank2_value": "up to +2 trust",
        "rank3_value": "up to +3 trust",
        "rank1": "Stage 1: If your trust is negative, an approved good deed restores up to 1 extra trust points, never above zero.",
        "rank2": "Stage 2: If your trust is negative, an approved good deed restores up to 2 extra trust points, never above zero.",
        "rank3": "Stage 3: If your trust is negative, an approved good deed restores up to 3 extra trust points, never above zero."
      },
      "C_GROUP_MENTOR": {
        "rank1_value": "+5% group experience points",
        "rank2_value": "+10% group experience points",
        "rank3_value": "+15% group experience points",
        "rank1": "Stage 1: Your contribution increases experience points for an approved group action by 5%.",
        "rank2": "Stage 2: Your contribution increases experience points for an approved group action by 10%.",
        "rank3": "Stage 3: Your contribution increases experience points for an approved group action by 15%."
      },
      "C_GUILD_BENEFACTOR": {
        "rank1_value": "+1 trust",
        "rank2_value": "+2 trust",
        "rank3_value": "+3 trust",
        "rank1": "Stage 1: An approved group action gives you 1 additional trust point.",
        "rank2": "Stage 2: An approved group action gives you 2 additional trust points.",
        "rank3": "Stage 3: An approved group action gives you 3 additional trust points."
      }
    },
    "stats": {
      "cooldown": {
        "label": "Waiting time",
        "description": "Receiving a reward starts the waiting time for that slot. For active group projects, it starts at registration. Withdrawal or cancellation releases the slot. Combined bonuses can reduce the wait by up to 80%."
      },
      "xp_bonus": {
        "label": "Total experience points",
        "description": "Extra total experience points for confirmed individual actions. The focus bonus applies in the matching category."
      },
      "cat_xp_bonus": {
        "label": "Category experience points",
        "description": "Extra experience points in the category of your confirmed individual action. General experience points bonuses also apply."
      },
      "gildex": {
        "label": "Group points",
        "description": "Your group receives extra Group points for confirmed individual actions. You keep all your experience points.",
        "base_xp": "{{percent}}% of base experience points"
      },
      "karma_rec": {
        "label": "Trust recovery",
        "description": "With negative trust, confirmed good deeds restore extra points, up to zero.",
        "talent": "+{{value}} trust (max +3, only with negative trust)"
      },
      "party_ep": {
        "label": "Group experience points",
        "description": "Confirmed group actions grant more experience points. The strongest focus bonus applies once; benefit bonuses are added."
      },
      "talent_rank": "Benefit engagement tier {{rank}}/3",
      "talent": "Benefit",
      "class": "Focus",
      "class_bonus": "Focus bonus",
      "talent_points": "Benefit points",
      "honor_heading": "Honor & trust",
      "xp_passive": "+{{percent}}% (max +10%: group +5%, upgrade +5%)",
      "karma_value": "+{{value}} trust",
      "karma_bonus": {
        "label": "Trust bonus",
        "description": "Extra trust you receive for a confirmed good deed. Your total trust follows the current system limit.",
        "base": "0 extra trust",
        "talent": "+{{value}} trust (max +3)"
      },
      "group_karma": {
        "label": "Group trust",
        "description": "Extra trust you receive for confirmed group actions.",
        "base": "0 extra group trust",
        "talent": "+{{value}} trust (max +3)"
      }
    },
    "ui": {
      "xp_progress": "experience points {{current}} / {{required}}",
      "xp_progress_aria": "Progress to next benefit point in experience points",
      "all_points_reached": "All benefit points reached",
      "upgrade_success": "Benefit engagement tier upgraded successfully!",
      "upgrade_failed": "The benefit could not be upgraded.",
      "tier_requirement": "Previous benefit at stage 2",
      "not_unlocked_yet": "Not learned yet. Unlock engagement tier 1 to activate this bonus.",
      "rank_badge": "Engagement Tier {{current}} / {{max}}",
      "max_rank_reached": "✓ Maximum Engagement Tier Reached (3/3)",
      "upgrade_to_rank": "Upgrade to Engagement Tier {{rank}} (1 Pt)",
      "unlock_rank_1": "Unlock Engagement Tier 1 (1 Pt)",
      "prereq_required": "First raise the previous benefit to stage 2.",
      "points_required": "You need an available benefit point.",
      "next_rank": "Next Engagement Tier ({{rank}}/{{max}}): {{desc}}",
      "footer_tip": "Tip: Each engagement tier upgrade (Engagement Tier 1 to 3) permanently boosts your member bonuses.",
      "loading": "Loading benefit trees...",
      "error_load": "Error loading benefit trees.",
      "origin_title": "Member Focus",
      "origin_subtitle": "Central Benefit Origin",
      "skill_tree_nav": "Select a circle to inspect the skill and its engagement tier path",
      "progression_path": "Benefit stages",
      "current_stage": "Current Engagement Tier",
      "next_stage": "Next Engagement Tier"
    },
    "tree": {
      "rank": "Engagement Tier {{rank}}",
      "requires_rank": "Previous benefit: stage {{rank}}"
    },
    "title": "Your benefits",
    "description": "As you gain levels, you earn benefit points. Use them to unlock bonuses for experience, group actions, and future submissions.",
    "path_subtitles": {
      "A": "Submissions/group points",
      "B": "experience points and trust",
      "C": "Trust and group"
    }
  },
  "categories": {
    "ENTERTAINMENT_GASTRO": "Leisure & Connection",
    "LOGISTICS_RETAIL": "Organization & Transport",
    "TECH_EDUCATION": "Education & Technology",
    "ECO_NATURE": "Environment & Nature",
    "HEALTH_WELLNESS": "Health & Wellbeing",
    "MOBILITY_OUTDOOR": "Mobility & Support",
    "CRAFTING_REPAIR": "Crafts & Repair",
    "FOOD_GROCERIES": "Food & Nutrition",
    "HARDWARE_FITNESS": "Sport & Exercise"
  },
  "classes": {
    "roles": {
      "SCOUT": "Mobility & Support",
      "MEDIC": "Health & Wellbeing",
      "SOCIAL": "Leisure & Connection",
      "TANK": "Sport & Exercise",
      "ENVIRONMENT": "Environment & Nature",
      "TECH": "Education & Technology",
      "CRAFTER": "Crafts & Repair",
      "NUTRITION": "Food & Nutrition",
      "LOGISTICS": "Organization & Transport"
    },
    "perks": {
      "SCOUT": "Approved good deeds in Mobility & Outdoor earn 20% more total and category experience points. You wait 10% less time between submissions.",
      "MEDIC": "Approved good deeds in Health & Wellness earn 20% more total and category experience points. While your trust is negative, each approved good deed restores one extra trust point, up to zero.",
      "SOCIAL": "Approved good deeds in Entertainment & Hospitality earn 20% more total and category experience points. Approved group actions award 10% more experience points to the group. The bonus applies only once, even with several Bards.",
      "TANK": "Approved good deeds in Fitness & Equipment earn 20% more total and category experience points. You can submit one additional good deed at the same time.",
      "ENVIRONMENT": "Approved good deeds in Environment & Nature earn 20% more total and category experience points. Your approved individual actions give your group 20% more Group points.",
      "TECH": "Approved good deeds in Tech & Education earn 20% more total and category experience points. Approved good deeds outside Tech & Education award 10% more experience points in their category.",
      "CRAFTER": "Approved good deeds in Crafting & Repair earn 20% more total and category experience points. You can revise one rejected individual action and submit it for review once more.",
      "NUTRITION": "Approved good deeds in Food & Groceries earn 20% more total and category experience points. Once per calendar week, you can activate a free Experience Bonus before an individual action. If approved, it gives 25% more total and category experience points.",
      "LOGISTICS": "Approved good deeds in Logistics & Retail earn 20% more total and category experience points. Once per calendar week, you can skip the wait until your next submission. You still need a free slot.",
      "GUARDIAN": "Approved good deeds in Social & Community earn 20% more total and category experience points. Every approved good deed grants one extra trust point, including group actions.",
      "default": "Main Focus Special Ability"
    }
  },
  "perks": {
    "titles": {
      "CLASS_V2_GUARDIAN_ABILITY": "Extra trust",
      "CLASS_V2_NUTRITION_ABILITY": "Experience Bonus",
      "CLASS_V2_TECH_ABILITY": "More experience points in other categories",
      "CLASS_V2_ENVIRONMENT_ABILITY": "More Group points for your group",
      "CLASS_V2_MEDIC_ABILITY": "Restore trust faster"
    },
    "CLASS_V2_SCOUT_CATEGORY": "Approved good deeds in Mobility & Outdoor earn 20% more total and category experience points.",
    "CLASS_V2_TANK_CATEGORY": "Approved good deeds in Fitness & Equipment earn 20% more total and category experience points.",
    "CLASS_V2_GUARDIAN_CATEGORY": "Approved good deeds in Social & Community earn 20% more total and category experience points.",
    "CLASS_V2_GUARDIAN_ABILITY": "Every approved good deed grants one extra trust point, including group actions.",
    "CLASS_V2_CRAFTER_CATEGORY": "Approved good deeds in Crafting & Repair earn 20% more total and category experience points.",
    "CLASS_V2_SOCIAL_CATEGORY": "Approved good deeds in Entertainment & Hospitality earn 20% more total and category experience points.",
    "CLASS_V2_SOCIAL_ABILITY": "Approved group actions award 10% more experience points to the group. The bonus applies only once, even with several Bards.",
    "CLASS_V2_LOGISTICS_CATEGORY": "Approved good deeds in Logistics & Retail earn 20% more total and category experience points.",
    "CLASS_V2_NUTRITION_CATEGORY": "Approved good deeds in Food & Groceries earn 20% more total and category experience points.",
    "CLASS_V2_NUTRITION_ABILITY": "Once per calendar week, you can activate a free Experience Bonus before an individual action. If approved, it gives 25% more total and category experience points.",
    "CLASS_V2_TECH_CATEGORY": "Approved good deeds in Tech & Education earn 20% more total and category experience points.",
    "CLASS_V2_TECH_ABILITY": "Approved good deeds outside Tech & Education award 10% more experience points in their category.",
    "CLASS_V2_ENVIRONMENT_CATEGORY": "Approved good deeds in Environment & Nature earn 20% more total and category experience points.",
    "CLASS_V2_ENVIRONMENT_ABILITY": "Your approved individual actions give your group 20% more Group points.",
    "CLASS_V2_MEDIC_CATEGORY": "Approved good deeds in Health & Wellness earn 20% more total and category experience points.",
    "CLASS_V2_MEDIC_ABILITY": "While your trust is negative, each approved good deed restores one extra trust point, up to zero."
  },
  "api": {
    "guild_unlock": {
      "already_unlocked": "This group upgrade is already unlocked.",
      "insufficient_gildex": "The group points account does not have enough Group points for this upgrade.",
      "requires_previous_boost": "Unlock the previous experience points Boost first."
    },
    "messages": {
      "guild_statistics_members_only": "Only members of this group can access its statistics.",
      "guild_founding_rank_required": "You need at least engagement tier {{rank}} to found a group.",
      "guild_founding_actions_required": "You need at least {{count}} approved good deeds to found a group.",
      "guild_founding_karma_required": "You need at least {{karma}} trust to found a group.",
      "guild_founding_cooldown": "Wait {{days}} days after your last group leadership ended before founding another group.",
      "settings_rank_requirement_invalid": "The minimum engagement tier must be F, E, D, C, B, A, or S.",
      "settings_karma_requirement_invalid": "Minimum trust must be within the current trust limits and above the Community Review revocation threshold.",
      "settings_karma_threshold_order_invalid": "Trust thresholds must remain in order (suspension, Community Review revocation, experience points deduction, partner block, positive tiers).",
      "settings_karma_xp_penalty_invalid": "Daily trust experience points deduction must be between 0 and 100 percent.",
      "guild_applicant_unavailable": "The applicant can no longer join a group.",
      "heroic_xp_audit_pending": "The pending experience points audit must be decided first.",
      "heroic_xp_balance_mismatch": "The experience points ledger does not match the current balance. The submission was not deleted.",
      "heroic_recalculate_admin_only": "Only active system administrators can recalculate experience points.",
      "heroic_tribunal_assessment_missing": "The original community review assessment is missing.",
      "heroic_xp_ledger_missing": "The original experience points ledger entry is missing for this submission.",
      "heroic_xp_participants_mismatch": "The experience points ledger no longer matches the confirmed participants.",
      "heroic_xp_negative_balance": "The experience points adjustment would create a negative balance.",
      "heroic_return_reviewer_only": "Only active community review moderators or system administrators can return submissions.",
      "class_change_unavailable": "The one-time focus change is no longer available or is not allowed for this account.",
      "class_change_same": "Please choose a different focus. Your one-time change has not been used.",
      "class_change_invalid": "This focus is unavailable. Your one-time change has not been used.",
      "benutzer_erfolgreich_aus_der_g_38": "User banned from the group successfully.",
      "gilden_sperre_erfolgreich_aufg_40": "Group ban lifted successfully.",
      "gilden_wappen_erfolgreich_hochgeladen": "Group emblem uploaded and updated successfully.",
      "gildenname_ist_erforderlich_un_23": "The group name is required and must not exceed 60 characters.",
      "gildenstandort_breiten_und_l_n_25": "The group location (latitude and longitude) is required.",
      "heldenklasse_erfolgreich_archi_8": "Focus archived successfully.",
      "heldenklasse_erfolgreich_wiede_9": "Focus restored successfully.",
      "keine_aktive_gilden_sperre_f_r_39": "No active group ban was found for this user.",
      "klassen_perk_erfolgreich_archi_12": "Focus perk archived successfully.",
      "klassen_perk_erfolgreich_wiede_13": "Focus perk restored successfully.",
      "mitglied_erfolgreich_aus_der_g_36": "Member removed from the group successfully.",
      "mitglied_erfolgreich_zum_gilde_46": "Member promoted to group administrator successfully.",
      "mitglied_nicht_in_dieser_gilde_35": "Member not found in this group.",
      "mitglied_nicht_in_dieser_gilde_45": "Member not found in this group.",
      "nur_gilden_administratoren_d_31": "Only group administrators may view membership applications.",
      "nur_gilden_administratoren_d_32": "Only group administrators may process membership applications.",
      "nur_verifizierte_mitglieder_di_31": "Only verified members of this group may access the group chat.",
      "nur_verifizierte_mitglieder_di_32": "Only verified members of this group may post in the group chat.",
      "nur_verifizierte_mitglieder_di_33": "Only verified members of this group may access group news.",
      "talent_erfolgreich_freigeschaltet": "Benefit unlocked successfully.",
      "guild_successor_required": "Appoint another group leader before leaving the group.",
      "guild_disband_confirmation_required": "Confirm disbanding the group before leaving as its last member.",
      "heroic_cooldown_active": "You can start another good deed after the {{minutes}} minute waiting time.",
      "heroic_base_xp_range": "Base experience points must be between {{minimum}} and {{maximum}} for this rating.",
      "heroic_category_xp_range": "Category experience points must be between {{minimum}} and {{maximum}} for this rating.",
      "class_perk_hero_class_not_found": "The focus was not found.",
      "class_perk_not_found": "The focus perk was not found.",
      "admin_delta_range": "The adjustment must be between −100 and +100; the current system limits apply to the trust score.",
      "heroic_group_resubmit_in_guild": "Create a withdrawn group action again through the group overview.",
      "heroic_review_moderator_only": "Only community review moderators can view open good deeds.",
      "heroic_reviewer_role_required": "Only approved community review moderators or administrators can review.",
      "heroic_appeal_reviewer_conflict": "The person who decided the appeal cannot review the new community review round.",
      "heroic_review_guild_conflict": "You cannot review a fellow group member's good deed.",
      "heroic_review_same_player_cooldown": "Wait for the review waiting time before reviewing this player again.",
      "heroic_first_review_xp_required": "Set base and category experience points in the first review, including rejections.",
      "heroic_moderator_rank_required": "Your engagement tier is below the current minimum for a Community Review application.",
      "heroic_moderator_karma_required": "Your trust is below the current minimum for a Community Review application.",
      "heroic_already_moderator": "You are already a community review moderator.",
      "heroic_appeal_guild_conflict": "You cannot decide an appeal from a fellow group member.",
      "heroic_adventurers_only": "Only members can use this feature.",
      "partner_qr_requires_approved_hero": "Only approved members can create a QR pass.",
      "partner_offer_rank_invalid": "Choose a valid minimum engagement tier.",
      "direct_chat_contact_restricted": "You can message group members or people with a pending group application.",
      "settings_xp_range_key_invalid": "Choose a valid good deed experience points range key.",
      "settings_xp_range_value_invalid": "experience points ranges must be whole numbers between 0 and 100,000.",
      "settings_xp_range_order_invalid": "The minimum experience points cannot exceed the maximum experience points.",
      "settings_gildex_rate_invalid": "The Group points rate must be between 0 and 100 percent.",
      "talent_not_found": "This benefit does not exist.",
      "talent_max_level": "This benefit is already at its maximum level of 3/3.",
      "talent_no_points": "You have no benefit points left.",
      "guild_chat_locked": "Unlock the group chat at the Group points first.",
      "guild_chat_members_only": "Only group members can use group chat.",
      "guild_emotes_locked": "Unlock the group chat and emote pack first.",
      "guild_pin_admin_only": "Only group administrators can pin messages.",
      "guild_news_title_required": "Enter a title for the group news post.",
      "guild_news_content_required": "Enter content for the group news post.",
      "guild_news_admin_only": "Only group administrators can create news posts.",
      "guild_news_remove_admin_only": "Only group administrators can remove news posts.",
      "guild_cannot_kick_self": "You cannot remove yourself from the group.",
      "guild_kick_admin_only": "Only group administrators can remove members.",
      "guild_cannot_kick_system_admin": "System administrators cannot be removed from a group.",
      "guild_cannot_ban_self": "You cannot ban yourself from the group.",
      "guild_ban_admin_only": "Only group administrators can ban members.",
      "guild_cannot_ban_system_admin": "System administrators cannot be banned from a group.",
      "guild_unban_admin_only": "Only group administrators can lift bans.",
      "guild_bans_admin_only": "Only group administrators can view banned members.",
      "guild_edit_admin_only": "Only group administrators can edit group details.",
      "guild_not_found": "The group was not found.",
      "guild_emblem_admin_only": "Only group administrators can change the emblem.",
      "guild_not_member": "You are not a member of this group.",
      "guild_promote_admin_only": "Only group administrators can promote members.",
      "guild_deputy_locked": "Unlock additional group administrators at the Group points first.",
      "guild_unlock_not_found": "The group upgrade was not found.",
      "guild_gildex_admin_only": "Only group administrators can spend Group points.",
      "guild_treasury_members_only": "Only group members can view the points account.",
      "group_action_members_only": "Only members of this group can access this action.",
      "group_action_active_members_only": "Only active group members can participate.",
      "group_action_admin_only": "Only group administrators can manage group actions.",
      "group_action_locked": "Unlock group actions at the Group points first.",
      "group_action_cooldown_active": "You can start another good deed after the waiting time ends.",
      "guild_already_founded": "You have already founded a group and cannot found another one.",
      "guild_membership_exists": "You already belong to a group. Leave it before founding a new one.",
      "guild_already_member": "You already belong to a group.",
      "guild_name_taken": "This group name is already taken. Choose another name.",
      "partner_contact_required": "Provide a contact for members with no more than 250 characters.",
      "karma_minimum": "The minimum trust score has already been reached.",
      "karma_maximum": "The maximum trust score has already been reached.",
      "account_suspended_karma": "This account was suspended because its trust is {{karma}} (suspension threshold: {{threshold}}). The temporary suspension ends on {{until}}.",
      "karma_partner_restricted": "Partner benefits are unavailable for suspended accounts or negative trust.",
      "karma_minimum_not_met": "Your trust is below the minimum required for this offer.",
      "heroic_cooldown_slot_unavailable": "This waiting time slot is no longer active. Please refresh the page.",
      "ungueltige_rolle": "Registration is only permitted as an Member or Partner.",
      "ungueltige_heldenklasse": "The selected focus is invalid.",
      "invalid_gildex_price": "The Group points price must be a nonnegative integer.",
      "account_successor_required": "Transfer group leadership to another member before deleting your account.",
      "group_xp_allocation_missing": "Please set the experience points allocation.",
      "group_xp_allocation_incomplete": "The saved experience points allocation is incomplete.",
      "group_xp_allocation_approval": "Please explicitly approve the organizer’s experience points allocation.",
      "group_xp_allocation_stale": "The review round has changed. Reload the action and review its current experience points allocation.",
      "class_elixir_unavailable": "Experience bonus is unavailable this week."
    },
    "status": {
      "429": "Too many reprojects. Please wait a moment."
    }
  },
  "faq_page": {
    "subtitle": "Good deeds, community review, experience points, groups, partners, and privacy",
    "sections": [
      [
        "Good Deeds & experience points",
        [
          [
            "How does Goodvale work?",
            "You self-report a good deed you actually performed, describe it, and submit encrypted evidence unless an eligible self-report applies. The community review reviews it independently. Global and category experience points are credited only after final verification."
          ],
          [
            "How much experience points is appropriate?",
            "Admin settings define six individual bands and eight separate group bands. Current group pools range from {{groupBand1}} experience points in band 1 to {{groupBand8}} experience points in band 8, before bonuses and allocation. The following examples show individual values. Time and effort reflect time, strain, and responsibility; planning and coordination reflect planning, coordination, and participants. Moderators must remain within the resulting range.\n\nGuideline & Examples:\n• {{xpBand1}} experience points: Environmental report or small specific assistance (low / simple)\n• {{xpBand2}} experience points: Collecting a bag of litter, shopping help, or 1h tutoring (medium / simple)\n• {{xpBand3}} experience points: Coordinated workshop or aid sorting (medium–high / coordinated)\n• {{xpBand4}} experience points: Repair afternoon or smaller collection drive (high / complex)\n• {{xpBand5}} experience points: Larger organized cleanup with team and disposal (exceptional / coordinated)\n• {{xpBand6}} experience points: Multi-week mentorship or lasting support network (exceptional / complex)\n\nDonations reward personal effort, never monetary or goods value."
          ],
          [
            "What do global and category experience points do?",
            "Verified experience points increase your personal level and engagement tier. Category experience points additionally increase your matching category level. Partners may gate offers by:\n• Engagement Tier or personal level\n• Total experience points or category experience points\n• Specific verified system good deeds\n\nOrdinary partner redemption does not spend or consume experience points."
          ],
          [
            "How do I earn and use category titles and badges?",
            "Each of the ten categories grants a title and badge at levels 2, 5, 10, 30, 50, 70 and 100. These require 200, 1,250, 5,000, 45,000, 125,000, 245,000 and 500,000 category experience points. Choose one currently unlocked title for your profile, or display none. When a verified deed crosses a milestone, the confirmation popup shows its badge and title. Titles and badges are cosmetic and do not grant professional authority. A reversed experience points award may lock a milestone again."
          ],
          [
            "What are cooldowns and parallel submissions?",
            "Individual actions and active group registrations share your slots. Open actions and active cooldowns each occupy a slot. Withdrawal or cancellation releases the slot immediately.\n\nFor individual actions, the waiting time starts when experience points is awarded. For group actions, it runs from registration and does not restart when experience points is awarded. “My slots” shows your current occupancy and remaining cooldowns."
          ],
          [
            "How does the experience points boost work?",
            "Alchemists can activate a free experience bonus before one individual submission per calendar week:\n• +25% global and category experience points on approval\n• Submission consumes the charge (even if rejected or withdrawn)\n• The weekly reset occurs Mondays at 00:00 UTC"
          ],
          [
            "Can I withdraw a good deed?",
            "Yes. In your submissions, you can withdraw your own good deed while it is under review:\n• Pending review assignments end immediately.\n• No reward or trust penalty is applied.\n• Approved or finally rejected actions cannot be withdrawn.\n• Withdrawing a group submission also cancels the entire group action."
          ]
        ]
      ],
      [
        "Community Review & Appeals",
        [
          [
            "Who may moderate?",
            "Members may apply from Engagement Tier {{tribunalRank}} and {{tribunalMinimum}} trust to become community review moderators. After admin approval, they can review cases. The following are excluded:\n• Own submissions or good deeds with own participation\n• Submissions from members of your own group\n• New review rounds following an appeal decided by yourself"
          ],
          [
            "Are there anti-cheat measures in moderation?",
            "Yes. To prevent fraud and mutual approvals, automated anti-cheat rules are enforced:\n• Self-review ban & group member restriction\n• Automatic cooldowns for repeated reviewer-user pairings\n• Mandatory review interleaving of other users\n\nAs a result, some submissions may only appear in the queue after a delay or after reviewing other good deeds."
          ],
          [
            "How many moderators review?",
            "The first assigned review fixes time and effort, planning and coordination, and base experience points. The required number of reviews depends on experience points thresholds:\n• Single review: For smaller good deeds\n• Multiple reviews: For medium to large good deeds (quorum decides by majority)\n• Admin review: For very high experience points values, at least one system admin must review"
          ],
          [
            "Is one rejection enough?",
            "Only when the fixed experience points require exactly one review. With multiple reviews, the quorum decides by majority. A 1–1 result automatically adds an independent third tie-break review. Submitters see the ongoing status and final outcome, not internal votes."
          ],
          [
            "How do appeals work?",
            "After a final rejection, you may file a reasoned appeal within the configured period:\n• A system admin decides whether to open a new independent review round.\n• The deciding admin cannot review that round.\n• The original evidence must still exist."
          ],
          [
            "How is an appeal different from the blacksmith's second review chance?",
            "An appeal challenges the rejection. You must explain why and file it within the configured period. A system admin decides whether to open a new review round; accepting the appeal does not approve the good deed.\n\nWith the “Second review chance” focus ability, a blacksmith can revise one of their own rejected individual actions once and submit it directly for another review. You must change the description or upload new evidence, and have an available submission slot. This ability is not tied to the appeal deadline. You cannot use it for the same action while an appeal is pending."
          ]
        ]
      ],
      [
        "Evidence & Privacy",
        [
          [
            "Which short videos can I submit as evidence?",
            "You can submit short videos (MP4, max 10 seconds, 10 MB) in three categories:\n• Activity: Shows your contribution in progress\n• Before: Shows the initial state before start\n• After: Shows the result from the same perspective"
          ],
          [
            "Are before-and-after videos reviewed faster?",
            "Two clear “Before” and “After” videos make review easier and may speed up verification. However, automatic approval is not guaranteed. Make sure to avoid filming other people's faces or private data."
          ],
          [
            "How is evidence protected?",
            "Evidence is securely protected:\n• Encrypted storage outside the public web directory\n• Verification of file size, type, signature, and hashes\n• Recording of upload timestamp and accepted privacy policy version\n• Audit logging for every read access"
          ],
          [
            "Who may view evidence?",
            "Evidence is visible exclusively to:\n• You as the submitter\n• The currently assigned community review moderator\n• Authorized system admins"
          ],
          [
            "How long is evidence retained?",
            "The system sets an expiry after the final decision. A background service then automatically removes the file and database record."
          ],
          [
            "What are my data rights?",
            "In your profile you can:\n• Download a machine-readable copy of your data\n• Anonymize your account (contact data and evidence are removed, login disabled)"
          ]
        ]
      ],
      [
        "Groups & Groups",
        [
          [
            "When can I found my own group?",
            "The World Group is your first stop to learn Goodvale and gain experience through approved good deeds. Founding a group requires at least engagement tier {{guildRank}}, {{guildActions}} approved good deeds of your own, and {{guildKarma}} trust. You must not already belong to a group. After dissolving your group or transferring its leadership, you wait {{guildCooldown}} days before founding another. Superadmins can change these requirements; the current values appear on the group creation page."
          ],
          [
            "How does group recognition work?",
            "Shared progress and unlocked benefits make your group’s contribution visible. Available points can be spent on internal group features."
          ],
          [
            "How do group good deeds work?",
            "A group leader announces a voluntary, non-commercial action on a separate form page. Invitations do not sign anyone up automatically. Everyone signs up individually, including the organizer if they want experience points. From the scheduled start, each person confirms their own actual participation. At least two confirmations are required. The organizer submits shared evidence and the experience points allocation. Rewards are credited only after final community review approval. Cancelling removes the action's invitation notifications; registered members receive a cancellation notification. Group admins can open the detailed guide through the info icon next to group actions."
          ],
          [
            "Why do group actions have separate experience points bands?",
            "Several members share one pool. Group bands can be configured independently of individual bands. All values apply before bonuses and allocation:\n\nBand · Individual action / Group pool\n1 · {{xpBand1}} / {{groupBand1}} experience points\n2 · {{xpBand2}} / {{groupBand2}} experience points\n3 · {{xpBand3}} / {{groupBand3}} experience points\n4 · {{xpBand4}} / {{groupBand4}} experience points\n5 · {{xpBand5}} / {{groupBand5}} experience points\n6 · {{xpBand6}} / {{groupBand6}} experience points\n7 · Groups only: {{groupBand7}} experience points\n8 · Groups only: {{groupBand8}} experience points\n\nThe pool does not automatically grow with participant count. Equal shares divide the configured group pool evenly; larger groups receive smaller shares per person.\n\nTime and effort plus planning and coordination determine the band. Groups also have “Extensive team effort” and “Multi-stage organization”. Both highest levels together give band 8. The community review assesses documented contributions and actual organizational work."
          ],
          [
            "How does the organizer allocate group experience points?",
            "Exactly 100% is allocated in whole percentages, exclusively to confirmed participants. Each person may receive 0–50%, including the organizer. At least two people need a positive share. Example for five people: 40 / 25 / 15 / 10 / 10%.\n\nThe community review must explicitly approve the allocation. Shares are locked during review. If the action is returned, the organizer can revise and resubmit them, starting a new review round. A 0% share gives neither experience points nor trust and contributes no group buff. The 50% cap applies before personal bonuses."
          ],
          [
            "What happens if someone does not turn up?",
            "Anyone who withdraws or does not confirm participation receives no reward and contributes no group buff. People who remain registered only are withdrawn at submission. Wait for everyone who actually participated to confirm.\n\nThere is currently no dedicated report button or automatic penalty for false participation confirmations. Before submission, the organizer can assign 0% and explain the situation in the description. After submission, the community review must return the action before changes can be made."
          ],
          [
            "How do buffs affect the group pool?",
            "The pool is calculated first: base experience points × event factor × (1 + group upgrade + group buff), rounded down. Saved percentage shares are then allocated, followed by personal bonuses. Global experience points and category experience points are calculated separately.\n\n• Only confirmed people with positive shares contribute group buffs.\n• The strongest Creator bonus applies once, normally 10%.\n• Group Mentor gives 5 / 10 / 15% by engagement tier; contributions from multiple people add together. Focus group bonuses and group benefits combined are capped at 50%.\n• Only the highest unlocked group upgrade applies (1–5%). The personal 5% group membership bonus applies after allocation.\n• The experience bonus is for individual actions only; temporary personal buffs do not apply here.\n\nExample: 2,000 base experience points, no event bonus, a 5% group upgrade, a 10% Creator bonus and 10% Group Mentor produce a pool of 2,500 experience points. Shares of 40 / 25 / 15 / 10 / 10% give 1,000 / 625 / 375 / 250 / 250 experience points before personal bonuses. Remainder experience points is preserved during allocation; personal experience points is rounded down afterwards.\n\nFocus and benefit effects are saved at submission and captured again on a revised submission. The event factor and group upgrade are fixed in the first community review review."
          ],
          [
            "May partners assign work through groups?",
            "No. Group good deeds must not replace a paid position, work shift, or normal commercial service. Group admins confirm the non-commercial and voluntary nature before announcing."
          ],
          [
            "What are Group points?",
            "Group points are internal group progression points with no monetary value:\n• On verified good deeds, the group receives a percentage of base experience points as Group points (your experience points are not reduced).\n• Group points cannot be purchased, cashed out, or transferred.\n• Group admins can spend Group points exclusively on internal group decorations and convenience features."
          ],
          [
            "What is the difference between group renown and Group points?",
            "• Group Renown: Reflects past overall progress from rewarded good deeds and determines how your group overview looks.\n• Group points: Available balance for internal unlocks (spending Group points does not reduce group renown)."
          ]
        ]
      ],
      [
        "Partners & QR Pass",
        [
          [
            "How do I redeem an offer?",
            "Open your QR pass:\n• A partner scans the code and sees authorized profile data.\n• Signature, expiry, user binding, and requirements are checked server-side."
          ],
          [
            "Can a screenshot be reused?",
            "No. The pass is signed, expires quickly, and contains a random one-time ID that is permanently invalidated upon first use."
          ],
          [
            "Are experience points money or currency?",
            "No. experience points are game progress with no monetary value. Progress unlocks partner offers; partners carry responsibility for fulfillment."
          ],
          [
            "Do focus areas change partner discounts?",
            "No. The regular discount of the partner offer always applies."
          ]
        ]
      ],
      [
        "Focus Areas, Perks & Trust",
        [
          [
            "Can I change my focus after registration?",
            "Yes. In your profile, select and confirm another available focus under “Change focus”. You can do this once within the first seven days (168 hours) after registration. Your profile shows the exact deadline. After using your change or after the deadline, you cannot change your focus again."
          ],
          [
            "What happens to my experience points and bonuses when I change focus?",
            "Previously awarded global and category experience points is not recalculated. Your levels and engagement tier also stay unchanged. Ongoing good deeds keep their saved bonuses; new good deeds use your new focus bonuses. Changing focus does not reset abilities you have already used."
          ],
          [
            "Which focus perks exist?",
            "All focus areas receive +20% global and category experience points for approved actions in their category. Specific abilities are:\n• Companion: 10% shorter waiting time\n• Tank: +1 slot for parallel submissions\n• Caretaker: +1 trust for every approved action\n• Blacksmith: Repair one rejected individual action once\n• Creator: +10% group experience points (non-stacking)\n• Organizer: Skip waiting time once a week\n• Provider: +25% experience points on one individual submission per week\n• Researcher: +10% category experience points outside own category\n• Nature Lover: +20% Group points from individual actions\n• Supporter: +1 recovery trust while negative (up to max 0)"
          ],
          [
            "Do benefits differ by focus?",
            "No. All focus areas share the same benefit paths and benefits. Your focus determines your focus ability; you can unlock benefits regardless of your focus."
          ],
          [
            "What is trust?",
            "Trust is your personal trust score ({{karmaMinimum}} to {{karmaMaximum}}):\n• Starts at 0 and is not a currency.\n• Direct trust deductions do not change experience points.\n• Higher trust unlocks trust tiers."
          ],
          [
            "How do I earn trust?",
            "Verified good deeds reward trust:\n• At least +1 trust per approved action (or configured reward)\n• Trust benefits additionally increase yield\n• Recovery bonuses apply while negative (up to 0)\n• Rejections or withdrawals do not reduce trust\n• For group actions, only confirmed people with positive experience points shares receive trust; a 0% share gives no trust."
          ],
          [
            "Who can deduct my trust?",
            "In case of misconduct or fraud:\n• Group admins may deduct trust from members of their group (1–100 points with reason).\n• Superadmins may act across groups.\n• You receive a notification with reason and admin identity."
          ],
          [
            "Does negative trust suspend my account?",
            "From {{partner}} to {{partnerEnd}} trust, partner benefits are blocked. From {{xp}} to {{xpEnd}}, {{percent}}% of total experience points is deducted daily. At {{tribunalLoss}}, an existing Community Review role is revoked. From {{suspension}} to {{karmaMinimum}}, the account is suspended for {{months}} calendar month(s). Verified good deeds rebuild trust."
          ],
          [
            "Where can admins manage trust?",
            "Admins can find “Manage trust” in the profile to search for users and issue trust deductions with a mandatory explanation."
          ]
        ]
      ]
    ]
  },
  "admin_directory": {
    "delete_guild": "Delete group",
    "delete_guild_confirm": "Permanently delete group “{{name}}”? All members leave the group, but their user accounts remain. Group data and unlocks will be deleted and ongoing group actions cancelled. This cannot be undone.",
    "guilds": "All groups",
    "karma": "Trust",
    "karma_suspended": "Temporarily suspended by trust",
    "karma_suspended_until": "Trust suspension until {{date}}",
    "manual_suspension_separate": "Manual account suspension is managed separately and is independent of the trust suspension.",
    "search_guilds": "Search group name or description …",
    "treasury": "Points Account",
    "total_xp": "Total experience points",
    "manage_guild": "Manage Group",
    "view_public": "Public Group Page",
    "stats_summary": "Group Key Metrics",
    "rate": "Group points Rate",
    "tab_karma": "Trust Moderation",
    "level_and_rank": "Level & Engagement Tier",
    "hero_class": "Focus",
    "karma_score": "Trust Score",
    "guild_hall": "Group Overview ({{name}})",
    "error_loading_guild_details": "Failed to load group details",
    "rate_label": "Rate: {{rate}}% Base experience points",
    "unlocked_upgrades": "Unlocked group upgrades",
    "actions_and_gildex": "Good Deeds & Group points Generation",
    "gildex_generated": "+{{amount}} Group points generated",
    "total_gildex_yield": "+{{amount}} Group points total yield",
    "guild_members_count": "Group Members ({{count}})",
    "guild_leader": "Group Leader",
    "xp_collected": "{{amount}} experience points collected",
    "no_members_in_guild": "No members in this group.",
    "guild_announcements_count": "Group Notices & Announcements ({{count}})",
    "class": "Focus",
    "no_guild": "No group"
  },
  "classesAndRanks": {
    "title": "Focus Areas",
    "subtitle": "Explore ten member focus areas and their abilities.",
    "classes": "Member focus areas",
    "classesIntro": "Choose a focus that suits your interests. You earn more experience points in its category and gain a special ability.",
    "perk": "Focus perk",
    "noPerk": "Your focus configuration shows the specific focus perk.",
    "loadError": "The focus configuration could not be loaded. Default values are shown."
  },
  "ranksGuide": {
    "title": "Engagement Tiers",
    "subtitle": "Your engagement tier grows with experience points earned from approved good deeds.",
    "ranks": "Engagement Tier progression",
    "ranksIntro": "Your engagement tier is based on all experience points you have earned from approved good deeds.",
    "xp": "total experience points",
    "noteTitle": "Level and engagement tier explained",
    "note": "Your level and engagement tier grow with total experience points from approved good deeds. You also earn separate experience points in each category.",
    "whyRanksTitle": "Why do engagement tiers matter?",
    "whyRanksIntro": "Your engagement tier shows your progress and matters for some opportunities in Goodvale:",
    "whyRanks": [
      {
        "title": "Found your own group",
        "text": "You need the required engagement tier and must meet the other conditions."
      },
      {
        "title": "Apply to the Community Review",
        "text": "Once you reach the required engagement tier, you can apply to review good deeds. Approval is required before you receive the role."
      },
      {
        "title": "Use partner offers",
        "text": "Some offers may require a minimum engagement tier. You can find the requirements on each offer."
      }
    ]
  },
  "landing": {
    "eyebrow": "Your contribution makes a difference.",
    "title": "The engagement begins in real life.",
    "guildFeature": {
      "title": "A group turns individual deeds into a shared engagement.",
      "intro": "A group connects you with people who share ideas, organize help, and celebrate progress. Join an existing community or start your own. Your group home shows what you have achieved together.",
      "points": [
        {
          "title": "Act together",
          "body": "Plan voluntary group deeds, sign up yourself, and confirm your participation. After Community Review approval, group experience is divided among confirmed participants. Focus and benefit bonuses can strengthen the shared result."
        },
        {
          "title": "Build the points account",
          "body": "Approved good deeds add Group points to the assigned group without reducing your own experience points. The group can unlock chat, group deeds, group home designs, and more with these shared resources."
        },
        {
          "title": "Share the benefits",
          "body": "Group membership already grants a general 5% experience points bonus. A group can unlock additional experience boost tiers with Group points. The highest purchased tier adds another 1 to 5 percentage points."
        }
      ],
      "closing": "Group renown, shared deeds, and unlocked rooms show how your community grows. Group leaders spend earned Group points on benefits for everyone.",
      "action": "Become an member"
    },
    "partnerFeature": {
      "points": [
        {
          "title": "Be visible locally",
          "body": "Use a partner profile to introduce your business, location, and offers. Members discover relevant benefits as they make progress through real good deeds."
        },
        {
          "title": "Shape your offers",
          "body": "Create discounts, extras, vouchers, or services. Set conditions such as engagement tier, experience points, category, trust, and approved event deeds, as well as availability periods and limits."
        },
        {
          "title": "Make redemption easy",
          "body": "On site, verify a short-lived QR pass. Eligible members redeem digital offers themselves. Manage offers and view redemptions in the partner area."
        }
      ],
      "closing": "Partner offers reward effort; they do not purchase experience points or engagement tiers. Partner accounts are reviewed after registration before offers can be published."
    },
    "roles_kicker": "Community",
    "roles_title": "Make a difference together",
    "karma_title": "Trust at a glance",
    "karma_intro": "The trust scale shows when benefits are blocked, Community Review rights are revoked, and other consequences apply. Select a threshold for details.",
    "karma_more": "Trust in detail",
    "subtitle": "Help others, support your neighborhood, and make your contribution visible. Find your focus, take action with your group, and discover benefits from local partners.",
    "join": "Join a group",
    "classesSubtitle": "Ten focus areas, one shared goal: make the world a little better through acts both big and small.",
    "cards": [
      [
        "Members",
        "Do good in everyday life—small gestures can make a big difference. Earn experience, engagement tier up, and unlock rewards."
      ],
      [
        "Community Review",
        "As an experienced guardian, review and verify submitted good deeds according to strict quality and honor standards."
      ],
      [
        "Groups",
        "Unite with like-minded allies, tackle collective challenges, and build up your group points account."
      ],
      [
        "Partners",
        "Support committed people in your local region and reward verified good deeds with real benefits."
      ]
    ],
    "hero_prefix": "Do good",
    "hero_emphasis": "together.",
    "categories_examples": "Good deed and experience points examples"
  },
  "partnerSettings": {
    "subtitle": "Manage your partner profile and your exclusive offers for members."
  },
  "guild_treasury": {
    "confirm": "Unlock \"{{name}}\" for {{price}} Group points?",
    "insufficient": "Not enough Group points.",
    "loading": "Loading points account...",
    "shop_title": "Group Shop & Catalog",
    "shop_intro": "Unlock exclusive hall themes, the common room, and upgrades for your group.",
    "title": "Group points Ledger & History",
    "rate": "Current conversion rate: {{rate}}% of base experience points",
    "no_money": "Group points cannot be purchased.",
    "admin": "Only group admins can spend Group points.",
    "base": "Base: {{xp}} experience points ({{rate}}%)",
    "shop_eyebrow": "GROUP SHOP"
  },
  "guildGildexTreasury": {
    "title": "Group points points account",
    "subtitle": "The group's shared reserves. Group points is proportionally added to the points account through approved good deeds."
  },
  "adminHeroicActions": {
    "reviewUnavailable": {
      "assignment": "You currently have no eligible review assignment. Assignment, group relationships and review cooldowns apply."
    },
    "tableHero": "Member",
    "keepWarning": "Awarded experience points, trust and group rewards are retained.",
    "reverseWarning": "Recorded experience points, category experience points, trust and group rewards are reversed, including group participants. Previously spent Group points can result in a negative group balance.",
    "reviewCategoryHint": "Check the selected category and correct it if needed. The first review fixes it for this review round; category experience points and bonuses use this category.",
    "badge": "Community Review & Moderation",
    "title": "Community Review",
    "subtitle": "Review pending good deeds and evaluate the effort and evidence of members.",
    "antiCheatNotice": "Notice: Due to anti-cheat measures (cooldowns, group filters, and review interleaving), some submissions will only appear in your queue after reviewing other good deeds or after a waiting period.",
    "xpLabel": "experience points and base values",
    "searchPlaceholder": "Search good deed or member…",
    "allRanks": "All engagement tiers",
    "allBands": "All experience points bands",
    "rank": "Engagement Tier",
    "xpBand": "experience points Band",
    "applications": "Applications for the Community Review",
    "organizerOkay": "Group organizer policy confirmed",
    "organizerMissing": "Group organizer policy pending",
    "heroEstimate": "Member estimate:",
    "assessHint": "Set binding time and effort, planning and coordination, and experience points rewards.",
    "baseGroup": "Base experience points (entire group)",
    "base": "Base experience points",
    "categoryGroup": "Category experience points (entire group)",
    "guidanceAdmin": "Admin review required (exceptional or high experience points)."
  },
  "adminAppeals": {
    "detailIntro": "Review the reason and decide whether to start a new community review round."
  },
  "quick_heroic_action": {
    "experience_elixir": "Experience Bonus: +25% experience points when approved."
  },
  "heroicActions": {
    "slots_full_redirect": "All slots are occupied by open projects or cooldowns. Visit My slots to see when a slot will become available.",
    "breakdown": {
      "total": "Total experience points",
      "category": "Category experience points",
      "guild": "Group bonus",
      "partyTalent": "Group benefit",
      "classBonus": "Focus bonus",
      "groupFormula": "Calculation: ⌊{{base}} × {{event}} × (1 + {{guild}}% group + {{party}}% party)⌋",
      "groupTotal": "Group experience points after event, group and party bonuses: {{total}}",
      "share": "Share before personal bonuses: {{xp}} experience points ({{percent}}% approved by the community review)",
      "legacyShare": "Share before personal bonuses: {{xp}} experience points among {{count}} participants",
      "credited": "Personally credited: {{xp}} experience points",
      "missingFactors": "Event/group effects and rounding that cannot be reconstructed individually: {{xp}} experience points",
      "rounding": "The event factor applies first. Group experience points are allocated by share with remainders distributed; personal bonuses are then applied and rounded down.",
      "legacyFactors": "Not all factors were saved for this older submission. The final credit comes from the experience points ledger."
    },
    "categoryXp": "category experience points",
    "eine_reparatur_pro_h": "One repair per good deed. Revise the description or submit a new evidence. The community review will review again.",
    "klassenf_higkeit": "Focus ability",
    "filterXp": "experience points Band",
    "allXpBands": "All experience points Tiers",
    "sortXpDesc": "experience points (Highest first)",
    "sortXpAsc": "experience points (Lowest first)",
    "xpFor": "experience points for",
    "closeXpBreakdown": "Close experience points breakdown",
    "showXpBreakdown": "Show experience points breakdown",
    "xpBreakdown": "experience points breakdown",
    "baseXp": "Base experience points set by the community review",
    "awardedXp": "Awarded experience points"
  },
  "heroicActionXpGuide": {
    "baseXp": "Base experience points",
    "title": "experience points guidance and examples",
    "intro": "Every good deed counts, including small everyday acts of kindness. Estimate how much time and effort your deed required and how much planning and coordination was needed. Together, these estimates determine a binding experience points band. The Community Review reviews your assessment and awards base experience points within that band. Focus and boost bonuses are applied afterwards.",
    "subtitle": "Guidance on time and effort, planning and coordination, and experience points bands",
    "estimatedXp": "Estimated experience points",
    "bandOption": "Band {{band}} ({{min}}–{{max}} experience points)",
    "groupBaseXp": "Base experience points in the group pool",
    "groupIntro": "Group actions have eight separate experience points bands with larger shared pools. The community review assesses documented joint effort. Participant count alone does not increase the pool. Bonuses apply to the pool before it is divided using saved percentage shares. Individual actions use their own six bands.",
    "mixedBandOption": "Band {{band}} · Solo {{soloMin}}–{{soloMax}} / Group {{min}}–{{max}} experience points",
    "groupBandOption": "Group band {{band}} ({{min}}–{{max}} experience points)"
  },
  "guild_administration": {
    "profile_title": "Group Details & Location",
    "profile_intro": "Update your group’s official details, purpose and location on the map.",
    "official_name": "Official group name",
    "description_label": "Group motto & philosophy / description",
    "description_placeholder": "Describe your group's ideals, good deed focus, and history...",
    "location_label": "Group location on the world map",
    "name_required": "Please enter an official group name.",
    "profile_saved": "Group details and location saved.",
    "emblem_title": "Group Emblem Forge",
    "emblem_settings_title": "Manage group emblem",
    "emblem_intro": "Customize your group's heraldic emblem. The banner represents your group throughout the kingdom and on profile cards.",
    "emblem_alt": "Group emblem",
    "emblem_admin_only": "Only group admins can edit and save the emblem.",
    "emblem_saved": "Group emblem saved.",
    "forge_upgrade_intro": "Unlock the advanced emblem forge in the group shop for more motifs and design options.",
    "theme_intro": "Explore your group layouts. Group leaders can select an unlocked design.",
    "unlock_in_shop": "→ Unlock in shop ({{price}} Group points)",
    "applications_intro": "Review applications from members who want to join your group.",
    "bans_title": "Group Bans & Banned Members ({{count}})",
    "bans_intro": "Banned players can no longer join this group. You can lift bans here at any time.",
    "no_bans": "No active group bans.",
    "ban_success": "\"{{name}}\" was removed and banned from the group.",
    "theme_title": "Group layouts",
    "theme_default_description": "A clear, welcoming overview for your group.",
    "theme_saved": "Your group layout was updated."
  },
  "guildDetail": {
    "active_adventurers": "{{count}} active members",
    "berpr_fe_neue_beitr": "Review new join reprojects from members.",
    "passe_das_wappen_dei": "Customize your group emblem. The emblem represents you throughout the kingdom.",
    "gebannte_spieler_k_n": "Banned players can no longer join this group. You can lift bans here at any time.",
    "abenteurer_aus_gilde": "Ban member from group",
    "gildenhaus_nicht_gef": "Group hall not found",
    "der_abenteurer_wird": "The member will be removed from the group immediately and their future join reprojects will be permanently blocked.",
    "zur_ck_zur_gilden_be": "Back to group overview",
    "wird_auf_visitenkart": "Displayed on business cards and in the news."
  },
  "adminClassCategoryManager": {
    "keine_klassen_vorhan": "No focus areas available.",
    "erkl_re_genau_wie_di_placeholder": "Explain exactly how this perk works and which good deeds, experience points, or partner benefits it affects..."
  },
  "gameMechanics": {
    "faire_xp_teilung": "Fair experience points sharing"
  },
  "guildMembersAdmin": {
    "der_abenteurer_wird": "The member will be removed from the group immediately and their future join reprojects will be permanently blocked.",
    "es_sind_derzeit_kein": "There are currently no members blocked for this group.",
    "gesperrte_abenteurer": "Banned members",
    "abenteurer_aus_gilde": "Ban member from group",
    "lade_gesperrte_abent": "Loading banned members...",
    "neue_beitrittsanfrag": "New join reprojects from members will appear here for review."
  },
  "systemEvents": {
    "karma": "Trust",
    "xp_multiplier": "+{{percent}}% experience points (×{{multiplier}})",
    "base_xp": "★ {{count}} experience points",
    "cat_xp": "🎖️ {{count}} Cat-experience points",
    "karma_reward": "👑 {{count}} Trust",
    "base_xp_label": "Base experience points",
    "cat_xp_label": "Category experience points",
    "bonus_xp": "+{{percent}}% Event experience points."
  },
  "worldMapView": {
    "gilde_betreten": "Enter group",
    "gildenruhm": "Group renown",
    "w_hle_eine_gilde_ode": "Select a group or partner on the map to see more details.",
    "guilds": "Groups",
    "guild_type": "Group"
  },
  "partnerDetail": {
    "adventurer_missing": "Member not found.",
    "adventurer_required": "Only approved members can redeem digital offers.",
    "how_to_redeem_desc": "Present your official Group QR Pass at the checkout or service desk. The partner scans your code and applies the perk instantly!"
  },
  "heroicOverview": {
    "karma": "Trust",
    "total_xp": "Total experience points"
  },
  "guild_overview": {
    "renown_and_stage": "Group Renown & Upgrade Stage",
    "renown_description": "Permanently accumulated base experience points from your group's credited good deeds.",
    "gildex_earned": "Group points Earned",
    "balance_suffix": "Group points balance: {{balance}}.",
    "guild_members": "Group Members",
    "ep_boost_title": "Magical experience points Boost",
    "ep_boost_active": "+{{percent}}% experience points bonus active",
    "ep_boost_inactive": "No experience points bonus active",
    "ep_boost_status_active": "experience points bonus active",
    "ep_boost_hint": "Unlock level 1 to earn more experience points for good deeds as a group.",
    "ep_boost_desc": "The magical fountain amplifies experience points earned by all group members from good deeds by {{percent}}%.",
    "ep_boost_upgrade": "Upgrade in Group Shop →",
    "ep_boost_activate": "Unlock in Group Shop →",
    "ep_boost_max": "Maximum experience points boost level reached (+5%)"
  },
  "guild_hall_stage": {
    "aria_label": "Group Overview",
    "bg_alt": "Group Overview Background",
    "banner_aria": "Group Crest & Banner",
    "banner_sprite_alt": "Group Banner",
    "default_guild_name": "Group Crest",
    "profile_wall_aria": "Profile Wall: Group Members",
    "trophy_shelf_locked": "Trophy Room (Group Shop)",
    "chest_aria": "Group Chest (Points Account)",
    "chest_title": "Points Account (Group points & Vault)",
    "shop_stall_aria": "Group Organization & Transport Stall",
    "shop_stall_sprite_alt": "Organization & Transport Stall",
    "shop_stall_title": "Group Catalog & Unlocks",
    "stammtisch_aria": "Group Stammtisch (Chat)",
    "stammtisch_unlocked": "Group Stammtisch",
    "stammtisch_locked": "Group Stammtisch (Group Shop)",
    "group_table_unlocked": "Group Conference Table (Group Actions)",
    "group_table_locked": "Group Action Table (Group Shop)",
    "admin_desk_aria": "Group Leader Desk (Administration)",
    "admin_desk_unlocked": "Admin Desk (Group Leadership)",
    "admin_desk_locked": "Group Leader Desk (Group Shop)",
    "anvil_aria": "Crest Anvil (Group Design)",
    "anvil_locked": "Crest Anvil (Group Shop)",
    "fountain_aria": "experience points Fountain",
    "fountain_sprite_alt": "experience points Fountain",
    "fountain_unlocked": "experience points Fountain (+{{percent}}% experience points Boost)",
    "fountain_locked": "experience points Fountain (Group Shop)"
  },
  "system_admin": {
    "adventurer_view": "Member View"
  },
  "partner_portal": {
    "brand_title": "Portal"
  },
  "partner_redemptions": {
    "subtitle": "Overview of all redemptions of your offers by members (On-Site and Remote/Digital).",
    "stat_adventurers": "Members Reached",
    "search_placeholder": "Search member, offer, group, or code …",
    "no_redemptions_desc": "Once members redeem your offers on-site via QR pass or digitally, they will appear here."
  },
  "partner_profile": {
    "bio_placeholder": "Describe your company, offerings, or special perks for members on the world map …"
  },
  "audit_ui": {
    "room": {
      "news": {
        "description": "News from your group"
      },
      "roster": {
        "description": "The people behind your group"
      },
      "trophies": {
        "title": "Shared achievements"
      },
      "stats": {
        "description": "Explore your group's renown and progress"
      },
      "settings": {
        "description": "Manage members and group settings"
      },
      "treasury": {
        "title": "Points account",
        "description": "Your shared group points account"
      },
      "forge": {
        "title": "Design group logo",
        "description": "Your group emblem and its design"
      },
      "design": {
        "title": "Group layouts"
      }
    },
    "all_guilds": "All groups",
    "view_hall_image": "View the full group overview image",
    "emblem": "Group emblem",
    "welcome": "Welcome to your group",
    "your_guild": "Your group",
    "home": "Group home",
    "updates": "Group updates",
    "news_hint": "Your group news will appear here.",
    "treasure": "Points account",
    "rooms": "Your group spaces",
    "unlock_shop": "Unlock in the group shop",
    "shop": "The group shop",
    "shop_heading": "Develop your group",
    "tools": "Group tools",
    "boost_discover": "Discover experience points bonus",
    "boost": "experience points bonus +{{percent}}%",
    "theme_alt": "{{theme}} and its adjoining group rooms",
    "themes": {
      "default": "Clear",
      "forest": "Nature",
      "celestial": "Stars"
    },
    "karma_designation": "Trust designation",
    "guild": "Group",
    "no_guild": "No group yet"
  },
  "categories_guide": {
    "intro": "Every good deed belongs to one area. Alongside your total experience points, you earn experience points in that category. Choose the category that best matches what you actually did.",
    "examples_link": "See examples and experience points"
  },
  "category_showcase": {
    "xp_caption": "Good deeds. Dedicated category experience points."
  },
  "landing_classes": {
    "heading_title": "Find your focus",
    "heading_subtitle": "Ten areas where your support matters.",
    "picker_label": "Choose a focus to preview",
    "loading_perks": "Loading focus perks …",
    "no_perks": "No perks are currently configured for this focus.",
    "selected_class": "Selected Focus",
    "explore_class": "Explore focus",
    "no_classes": "No focus areas are currently available.",
    "choose_class_title": "Choose your focus",
    "choose_class_hint": "Click an emblem or the button to choose your focus."
  },
  "good_deed_examples": {
    "intro": "These examples show roughly how effort relates to experience points. Reviewers assess what you actually did and the evidence; the numbers are guidance.",
    "table_label": "experience points examples",
    "xp_title": "How are experience points determined?",
    "xp_intro": "Time, effort, responsibility, planning, coordination, and the people involved all matter. For donations, your own work counts, not the monetary value. experience points are awarded only after final approval."
  },
  "guildHeroicActions": {
    "statuses": {
      "PendingReview": "At community review"
    },
    "chat": {
      "submitted": "[HEROIC ACTION] {{title}} was submitted to the community review with {{count}} confirmed participants.",
      "evidenceUploaded": "[HEROIC ACTION] {{title}}: The encrypted evidence was uploaded and the action was sent to the community review."
    },
    "adminOnly": "Only group admins can announce group good deeds.",
    "intro": "Group members coordinate together. The organizer allocates verified experience points; the community review reviews the allocation.",
    "locked": "Group good deeds are locked. A group leader can unlock them in the Group points shop.",
    "split": "base experience points, then allocated by the organizer",
    "allocationTitle": "experience points allocation",
    "submit": "Submit to community review",
    "resubmit": "Resubmit to community review",
    "allocationFor": "experience points share for {{name}}",
    "allocationBonuses": "These shares apply before personal bonuses. Whole experience points are rounded with remainder allocation, so amounts may differ by less than 1 experience points.",
    "allocationReviewTitle": "Organizer experience points allocation",
    "allocationApprove": "Have you reviewed and approved the organizer’s experience points allocation?",
    "guideLink": "Explain group action workflow and experience points"
  },
  "groupActionGuide": {
    "eyebrow": "Guide for group admins",
    "intro": "Anna organizes a litter cleanup with Ben, Clara, David and Eva. Follow the action from invitations to rewards, including withdrawals, community review decisions and experience points bonuses.",
    "navigation": [
      "Workflow",
      "No-shows",
      "experience points & buffs",
      "Decisions & completion"
    ],
    "steps": [
      {
        "title": "Announce the action",
        "text": "The group needs the Group Actions unlock. Open the separate form page with “Announce good deed”. Set the title, description, category, difficulty, complexity and date; a signup deadline and participant limit are optional. Confirm voluntary participation, a non-commercial purpose, safe organization and that the action does not replace paid work. Members are notified."
      },
      {
        "title": "Invite and sign up individually",
        "text": "Invitations do not register anyone automatically. All five sign up themselves, including Anna if she wants experience points. Registration requires and occupies an available good-deed slot. Until submission, participants can withdraw and the group leader can cancel the action. Cancelling removes the action's invitation notifications; registered members receive a cancellation notification."
      },
      {
        "title": "Participate and confirm yourself",
        "text": "From the scheduled start, each person confirms their own actual participation. There is no confirmation on someone else’s behalf or mutual confirmation. Wait for everyone who took part before submitting: at least two confirmations are required. People who remain only registered are withdrawn when the action is submitted."
      },
      {
        "title": "Allocate 100% in whole percentages",
        "text": "Anna could assign 40 / 25 / 15 / 10 / 10%. No person may receive more than 50%, including Anna. Only confirmed participants count. Zero is allowed, but at least two people need a positive share. Decimal percentages are not allowed. With more than 100 people, some must receive 0%. Participants do not separately approve the allocation."
      },
      {
        "title": "Upload shared evidence",
        "text": "Choose an image, PDF or MP4 and acknowledge the privacy notice. The submission is saved first, then the evidence is uploaded. If the upload fails, you can retry it. Only then does the action go to the community review. Shares are locked during review."
      },
      {
        "title": "The community review decides",
        "text": "The community review reviews the evidence and allocation. The first review sets category, difficulty, complexity, base experience points and category experience points. Each approval must explicitly accept the allocation. Reviewing your own action is prohibited; regular moderators cannot review their own group’s actions either. Rewards are booked once the required reviews approve the action."
      }
    ],
    "absence": [
      {
        "title": "Eva withdraws or does not confirm",
        "text": "Eva receives no experience points and contributes no group buff. If she remains registered only, submission automatically withdraws her. Anna allocates 100% among the remaining confirmed participants. Someone who participated but forgot to confirm is also excluded this way."
      },
      {
        "title": "Eva falsely confirms participation",
        "text": "There is currently no dedicated no-show report button, attendance verification or automatic penalty. Before submitting, Anna can assign 0% and explain the situation in the description. Eva remains technically confirmed, but receives neither experience points nor trust and contributes no group buff. After submission, the community review must return the action before shares can change."
      },
      {
        "title": "What the percentage rule does not check",
        "text": "A positive share of 1% or more enables the person’s full applicable group buff. The system does not verify a minimum contribution. Actual contributions must be clear from the description, evidence and community review review."
      }
    ],
    "xpTitle": "How experience points and buffs work",
    "xpIntro": "A shared experience points pool is calculated first, then divided using the saved shares. Personal bonuses apply to each person’s share afterwards. Global experience points and category experience points are calculated separately.",
    "rules": [
      "Exactly 100% in total, using only whole percentages from 0 to 50 per confirmed person.",
      "At least two positive shares. For three people, the equal suggestion is 34 / 33 / 33%.",
      "The 50% cap applies before personal bonuses. It does not cap a person’s proportion of all final credited experience points."
    ],
    "formula": "Group pool = floor(base experience points × event factor × (1 + group upgrade + group buff))",
    "example": "Example in group band 5: the community review awards 2,000 base experience points and 2,000 category experience points. No event bonus (factor 1), a 5% group upgrade, 10% from Ben as a Leisure & Connection and 10% from Clara’s engagement tier 2 Group Mentor produce pools of 2,500 each. All five also have the personal 5% group membership bonus. Anna is a Environment & Nature with another 20% in Environment & Nature. David is a Education & Technology with another 10% category experience points here. We assume no other benefits.",
    "columns": [
      "Person",
      "Share",
      "Pool share",
      "Global experience points",
      "Category experience points"
    ],
    "rows": [
      [
        "Anna · Nature Lover",
        "40%",
        "1000",
        "1250",
        "1250"
      ],
      [
        "Ben · Creator",
        "25%",
        "625",
        "656",
        "656"
      ],
      [
        "Clara",
        "15%",
        "375",
        "393",
        "393"
      ],
      [
        "David · Researcher",
        "10%",
        "250",
        "262",
        "287"
      ],
      [
        "Eva",
        "10%",
        "250",
        "262",
        "262"
      ],
      [
        "Total",
        "100%",
        "2500",
        "2823",
        "2848"
      ]
    ],
    "rounding": "Remainder experience points is distributed deterministically so no pool experience points is lost. Whole-experience points rounding may differ from the exact percentage by less than 1 experience points per person. Personal experience points is rounded down afterwards.",
    "buffs": [
      "experience points events multiply base experience points. Without an active event, the factor is 1.",
      "Group upgrade: only the highest unlocked tier applies (1–5%). Group membership also gives a separate personal 5%.",
      "Leisure & Connection: a standard 10% group bonus. Multiple Bards do not stack this focus bonus; only the strongest focus group bonus applies.",
      "Group Mentor: 5 / 10 / 15% by engagement tier. Contributions from multiple people add together. Focus group bonuses and group benefits combined are capped at 50%.",
      "Only confirmed people with positive experience points shares contribute group buffs. A buff is not reduced in proportion to its owner’s share.",
      "Matching focus bonuses normally add 20% global and category experience points. Personal experience points bonuses add together; category-only bonuses affect category experience points only.",
      "The weekly experience bonus applies only to individual actions. Temporary personal buffs are not included in these group rewards."
    ],
    "buffTiming": "Focus and benefit effects are saved per person at submission and captured again on a revised submission. The event factor and group upgrade are fixed in the first community review review. Later changes do not retroactively increase the current review round.",
    "outcomes": [
      {
        "title": "Returned for revision",
        "text": "Anna can revise the description and allocation and resubmit with evidence. A new review round begins; previous approvals do not apply. The community review does not edit the shares itself. While returned, the action does not occupy an open slot."
      },
      {
        "title": "Rejection and appeal",
        "text": "Rejection pays no rewards. The submitter or confirmed participants may file a reasoned appeal, by default once within 30 days and with the original evidence. An independent system admin decides. An accepted appeal starts a new community review round; it does not pay experience points yet."
      },
      {
        "title": "Number of reviews",
        "text": "By default, up to 150 group experience points requires one review, up to 500 requires two, and above 500 requires three. At 500 or more, an admin review must be included. A tied vote requires another review."
      },
      {
        "title": "Trust, Group points and notifications",
        "text": "People with positive shares normally receive at least 1 trust, plus applicable personal bonuses. Community Review-awarded honor is divided equally among positive-share recipients. A 0% share gives neither experience points nor trust. The group receives Group points once from base experience points, normally 10%: 200 Group points in this example. All confirmed people are notified of the result, including those with 0%."
      },
      {
        "title": "Slot and waiting time",
        "text": "The group waiting time starts at registration, normally 24 hours, potentially reduced by effects. While the action remains open, the slot stays occupied even if this timer has elapsed. Reward payment does not restart the timer. Withdrawal, cancellation or rejection releases the open reservation."
      },
      {
        "title": "Leaving the group during an action",
        "text": "Leaving or being removed ends active participation. A submitted action is cancelled if fewer than two confirmed people remain. If others remain, an allocation made invalid by the departure is not automatically redistributed; it must be resolved before approval, with a returned revision if necessary."
      }
    ],
    "defaults": "These numbers explain current defaults. Admins can configure review thresholds, cooldowns, Group points rates and focus effects. Older saved allocations remain intact for payment and recalculation; new or revised allocations use whole percentages.",
    "assessmentBands": "The two scales determine the band number. Extensive team effort with “Highly planned”, or “Very high” effort with multi-stage organization, gives group band 7 (4,000–6,000 base experience points by default). Both new highest levels give group band 8 (6,000–10,000). Group bands 1–6 also have their own larger pools. All group values are configurable independently of individual actions.",
    "assessmentExample": "Example: several teams improve a community space over multiple workdays. Materials, permissions, work phases and handovers between organizations need documented coordination. Both new levels may fit; the community review decides based on actual contributions."
  },
  "systemCopy": {
    "16885658fbb9": " (Gruppenpunkte)",
    "b5451aaa13ba": "Mitglied",
    "d658d199540c": "0 experience points",
    "42e2aa5470e7": " experience points",
    "9717eb352337": "Experience Bonus",
    "3ba62c293ab6": "Gain 25% more experience points for one individual deed per week.",
    "450864ab665b": "Einmal pro Woche 25 % mehr Erfahrungspunkte für eine Einzeltat.",
    "b6fbffaeb18a": " group-shop",
    "5b3e5f590e60": "Gruppenpunkte",
    "356db5eb31f6": " Gruppenpunkte",
    "198fb678c812": "Group statistics",
    "dbbcc055fb26": "Bestätigte gute Taten",
    "5b11fe2f04f5": "Gruppenpunkte verdient",
    "32d823725418": "Gruppenpunkte earned",
    "15a3179e1e7c": "gute Taten gegenüber dem vorherigen gleich langen Zeitraum:",
    "bae279e8bf55": "Gezählt ab Bestätigung, Zeitgrenzen in UTC. Historische Leistungen bleiben bei der damaligen Gruppe.",
    "eda3a54706dc": "Counted from approval, with UTC period boundaries. Historical contributions stay with their original group.",
    "84283337e247": "gute Taten im Zeitverlauf",
    "71bcfe99e01b": "In diesem Zeitraum wurden noch keine gute Taten bestätigt.",
    "7bd7d6d2efe7": "Aktive Mitglieder im Verhältnis zur gesamten Gruppe",
    "b5cacdba5528": "Active members compared with the whole group",
    "5f9d50483c1f": "Aktiv: mindestens eine bestätigte Einzelaktion für die Gruppe oder Teilnahme an einer bestätigten Gruppenaktion. Gruppenteilnahmen zählen je Aktion, auch von ehemaligen Mitgliedern.",
    "4c6cf7cc1111": "Active: at least one approved individual deed for this group or participation in an approved group deed. Participations count per deed, including former members.",
    "238c6eef4ba3": "Mit eurer ersten bestätigten gute Tat erscheint hier eure Wirkung nach Kategorien.",
    "3eb20d7dca1d": "Jede gute Tat zählt einmal, unabhängig von ihrer Teilnehmerzahl.",
    "325ba8c1e5d9": "Gruppenpunkte & Ausbau",
    "f4e4094a94ea": "Gruppenpunkte & development",
    "90d3ccca50df": "Gruppenpunkte-Einnahmen und Ausgaben im gewählten Zeitraum",
    "ee36e9ddce32": "Gruppenpunkte earned and spent in the selected period",
    "2f1d49da1e23": "Direkt beigetragene Gruppenpunkte",
    "06097c96531f": "Directly contributed Gruppenpunkte",
    "4d7fdae14b17": "Gruppenbelohnungen gehören der Gruppe und werden hier nicht auf einzelne Mitglieder aufgeteilt.",
    "fd5c00369a49": "Group rewards belong to the group and are not divided among individual members here.",
    "3e637b9d2de6": "Unlock the Trophy Room in the Gruppenpunkte shop to open this gallery.",
    "982a1365d123": "Schaltet den Gemeinsame Erfolge im Gruppenpunkte-Shop frei, um diese Galerie zu öffnen.",
    "9cb479db5d4b": "Group legacy",
    "73d8a14f8596": "Vermächtnis der Gruppe",
    "dc596278d9f5": "A lasting record of the group’s verified deeds and the members who accomplished them together.",
    "ec8d38bd7fe7": "Loading the group’s achievements…",
    "80572bae1749": "Lade die Erfolge der Gruppe…",
    "f5edf45aeade": "Unlock Group Good Deeds in the Gruppenpunkte to start creating shared achievements.",
    "230b5c30d1bf": "Schaltet Gruppenaktionen im Gruppenpunkte frei, um gemeinsame Erfolge zu schaffen.",
    "9efd79edc63b": "Gruppenlogo gestalten",
    "6722387741d7": "Gruppenlogo-Baukasten (Elemente)",
    "b4b39cdd92fe": "Logo-Editor Freigeschaltet",
    "2e83774788fc": "Zufällige Gruppenlogokombination",
    "3f12c55949e4": "Gruppenlogo Live-Vorschau",
    "2ffc7869e9b2": "Heraldisches Gruppenlogo",
    "3d87aefea2a1": "Logo-Editor Preview",
    "419dedf5e19c": "This logo uses additional design elements. Unlock the advanced logo editor in the group shop with group points to use it.",
    "584aea7f9abe": "Dieses Gruppenlogo nutzt exklusive Schmiede-Elemente. Schalte die \"Erweiterte Logo-Editor\" im Gruppen-Shop mit Gruppenpunkte frei, um es dauerhaft zu speichern.",
    "831cefa91ceb": "Open points account",
    "0122936e8034": "Zur Gruppenpunkte-Punktekonto",
    "c36f48b7d236": "Klassische Standard-Gruppenlogo",
    "d2b13ba3aa87": "Wähle eine bewährte Standard-Kombination oder wechsle zum Gruppenlogo-Baukasten für individuelle Elemente.",
    "2f03025fd913": "In der Vorschau ziehen oder die Regler verwenden. Änderungen werden im Gruppenlogo gespeichert.",
    "2dd43870a02b": "Krone, Ritterhelm, Flamme oder Zinnen auf dem Gruppenlogo:",
    "111aabea36e8": "Lower base finish, group ribbon banner, or gem pendant:",
    "0abdafe40412": "Unterer Gruppenlogoabschluss, Gruppen-Banner oder Quaste:",
    "c6c2f4224b32": "Wähle den metallischen Glanz und die Farbtönung des Gruppenlogos:",
    "f1e9205cbb92": "Logo-Editor",
    "168aad3e9812": "experience points",
    "a9127cc07e92": "experience points-Hilfe und Beispiele",
    "6a389d6c728d": " Vertrauen",
    "6b2f2ecdd84a": " world-trust--stages",
    "eeafe73f02c8": "Höchste Erfahrungspunkte",
    "3b3f1e54984f": "Niedrigste experience points",
    "f0a96bd6bf15": "Group Master",
    "8bc9c6dd8644": " % experience points",
    "687dfd0ceeee": "Gruppe:",
    "e3e062929a2f": "Failed to apply emblem during group creation",
    "31ba47f1fae3": "News",
    "08db035d1806": "Gruppenruhm und Aktivität sind derzeit nicht verfügbar.",
    "845d8127c1b4": "Gruppenruhm und Aktivität konnten nicht geladen werden.",
    "a0a2ab9585a4": "Gruppenübersicht konnte nicht geladen werden.",
    "222a24fd9aa5": "Gruppen-Neuigkeiten konnten nicht geladen werden.",
    "1c07813d09ea": "Gruppenchat konnte nicht geladen werden.",
    "516773403e48": "Die angeforderte Gruppe existiert nicht.",
    "21e1aeea2c1b": "Gruppenverwaltung & Einstellungen",
    "f933fee4b73b": "Gruppenruhm & Statistiken",
    "8e21174aef60": "Erfordert Gruppenpunkte Freischaltung (Vize-Admin)",
    "867d4690e877": "Aus Gruppe entfernen (Kick)",
    "5e0664b086b3": "Dauerhaft aus Gruppe bannen",
    "ee84b83e2a24": "Du kannst nur einer Gruppe gleichzeitig angehören.",
    "e47bab3c5826": "Erfahrungsbonus: +25 % Gesamt- und Kategorie-Erfahrungspunkte bei Bestätigung, ohne Erfahrungspunkte-Kosten.",
    "a9096aac522c": "World Group",
    "ab83d1ff771b": "Vertrauen-Score",
    "55681e642a13": "Failed to fetch news feed",
    "00dc19d908f2": "Fehler beim Laden der Schwerpunktedaten.",
    "ccdf9223f7db": " neuen Schwerpunkt",
    "8de641bae922": " Schwerpunkte & Perks (",
    "504823c82e3b": "Schwerpunkt bearbeiten",
    "e6ee49712127": "Schwerpunkt bearbeiten",
    "28b620216833": "Neue Schwerpunkt anlegen",
    "a05731e81733": "Rolle / Schwerpunktetyp",
    "05b1b5e96c06": "Tailwind color class",
    "c58be06c1a93": "Schwerpunkte-Perk bearbeiten",
    "eff481858079": "Gesamt- und Kategorie-experience points-Bonus",
    "90e7928d0517": "Party-Buff (Gruppen-experience points)",
    "0f154384cef7": "Ehren-Vertrauen Bonus (+1 Vertrauen)",
    "11c40a51d425": "Vertrauen-Erholung bei negativem Vertrauen",
    "124911b8368c": "Kategorie-Erfahrungspunkte außerhalb der Zielkategorie",
    "db729f7363ab": "Erfahrungsbonus (wöchentlich)",
    "031b655d8aaa": "Erholungs-Vertrauen bis 0",
    "11fc673ba9d9": "Kategorie-experience points-Bonus",
    "7558dba0c23d": "Gruppenpunkte-Einzahlungsbonus",
    "8d7a465d4068": "Gruppen-Vertrauen-Bonus",
    "70fddef742f8": "Wirkungswert (z.B. 0.20 = +20 %, 1 = +1 Slot/Vertrauen)",
    "63f8d339cf42": "Community Review Moderation",
    "54dcaca4c076": "Community Review (",
    "75deb356299a": "Gruppen (",
    "633ba960808f": "Zum Community Review",
    "c6d1fc947dc9": "Im Gute-Taten-Community-Prüfung prüfen",
    "c466734f5af1": "experience points ×",
    "10c26d79140f": "experience points-Vorschau konnte nicht geladen werden.",
    "8118de5cc29c": "experience points wurden neu berechnet und die Differenz gebucht.",
    "c8db42d0bd0d": "experience points konnten nicht neu berechnet werden.",
    "6f14360d1a0d": "Einstufung & experience points-Vergabe",
    "3d62c442615b": "Passe Schwierigkeit und Komplexität an, um das verbindliche Erfahrungspunkte-Band festzulegen.",
    "1f7c933aceb6": "Basis-experience points (Gruppe)",
    "26b475ca7301": "Kategorie-experience points (Gruppe)",
    "a73feda6e2f7": " experience points.",
    "c65a3b3858ce": " experience points neu berechnen",
    "5d35f4fca941": "Gesamt-experience points:",
    "cb874e449969": " · Kategorie-experience points:",
    "b35858b78ad4": " experience points, Kategorie",
    "c23e3acfe229": "experience points-Hilfe",
    "78b14b08dc14": "Gute Tat oder Mitglied…",
    "1443b9f2211c": "Alle Erfahrungspunkte-Bänder",
    "1698e4ae6293": "e.g. Community Café",
    "a677958fe6cc": "community-cafe",
    "e00e689f3fc3": "info@example.org",
    "0e6ec4da3067": "Genehmigte Bewerber erscheinen hier als aktive Community Review-Moderatoren.",
    "f4a2115ad657": " experience points /",
    "21591951cece": " experience points)",
    "a190c9987e71": " experience points ·",
    "e166da59b506": "Mitglied (D)",
    "4c99fbbb2a76": "Beschreibe dein Angebot und wie Mitglied es einlösen können (z.B. Zeige deinen Gruppenpass an der Kasse oder nutze den Online-Code)...",
    "3937a00a22e5": "Standard: Für alle Mitglied offen (ab Rang F)",
    "c7c3aa207e26": "Mindest-Gesamt-experience points (optional)",
    "b001b3bb128a": "Mindest-Kategorie-experience points",
    "438e079b21c4": "Mindest-Vertrauen (optional)"
  },
  "effectDescriptions": {
    "CategoryRewardBonus": "{{percent}}% more total and category experience points for approved good deeds in {{category}}.",
    "CategoryExperienceBonus": "{{percent}}% more category experience points in {{category}}.",
    "GuildGildexContributionBonus": "{{percent}}% additional group points from your approved individual deeds for your group.",
    "HeroicActionXpBonus": "{{percent}}% more experience points for approved good deeds.",
    "PartyBuff": "{{percent}}% more group experience points. Multiple identical focus bonuses do not stack.",
    "KarmaBonus": "{{value}} additional trust per approved good deed, including group deeds.",
    "GroupKarmaBonus": "{{value}} additional trust for approved group deeds.",
    "KarmaRecoveryBonus": "{{value}} additional recovery trust while trust is negative.",
    "OtherCategoryExperienceBonus": "{{percent}}% more category experience points outside {{category}}.",
    "WeeklyExperienceElixir": "Activate before an individual deed once per calendar week: {{percent}}% more total and category experience points on approval.",
    "ClassKarmaRecovery": "While trust is negative, gain {{value}} additional recovery trust per approved deed, up to 0."
  },
  "unlocks": {
    "STAMMTISCH": {
      "name": "Group chat",
      "description": "Unlocks the group space and internal text chat for your group members."
    },
    "DEPUTY_ADMIN": {
      "name": "Additional group leader",
      "description": "Allows the group leader to appoint deputies to help manage the group."
    },
    "HALL_THEME_FOREST": {
      "name": "Nature group layout",
      "description": "Style your group overview with calm natural colors."
    },
    "GROUP_HEROIC_ACTIONS": {
      "name": "Group good deeds",
      "description": "Allows your group to start joint good deeds and master larger projects as a team."
    },
    "GUILD_EMOJI_PACK": {
      "name": "Group chat Plus",
      "description": "Unlocks group emotes, message reactions, pinned messages, and polls in group chat."
    },
    "BANNER_FORGE_ADVANCED": {
      "name": "Advanced logo editor",
      "description": "Unlocks advanced editing and design options for your group logo."
    },
    "TROPHY_ROOM": {
      "name": "Shared achievements"
    },
    "HALL_THEME_CELESTIAL": {
      "name": "Stars group layout",
      "description": "Style your group overview with the Stars layout."
    },
    "EXP_BOOST_1": {
      "name": "Experience bonus I",
      "description": "Passively grants all group members +1% experience points for their good deeds."
    },
    "EXP_BOOST_2": {
      "name": "Experience bonus II",
      "description": "Passively grants all group members +2% experience points for their good deeds."
    },
    "EXP_BOOST_3": {
      "name": "Experience bonus III",
      "description": "Passively grants all group members +3% experience points for their good deeds."
    },
    "EXP_BOOST_4": {
      "name": "Experience bonus IV",
      "description": "Passively grants all group members +4% experience points for their good deeds."
    },
    "EXP_BOOST_5": {
      "name": "Experience bonus V",
      "description": "Passively grants all group members +5% experience points for their good deeds."
    }
  },
  "legalContent": {
    "title": "Legal & Privacy",
    "updated": "Last updated: September 28, 2026",
    "tabs": [
      "Legal Notice",
      "Terms of Use",
      "Privacy"
    ],
    "sections": [
      [
        [
          "Service Provider",
          [
            "Goodvale",
            "Operator: Dipl. Ing. Thomas Johannes Trügler",
            "Contact: thomas@truegler.io",
            "Privacy: thomas@truegler.io"
          ]
        ]
      ],
      [
        [
          "1. Platform Purpose",
          [
            "Goodvale is a gamification platform for voluntary, self-reported good deeds. The community review reviews evidence and awards experience points. experience points represent game progress, are not transferable or redeemable for cash, and have no fixed monetary value."
          ]
        ],
        [
          "2. Voluntary Participation and No Concealed Work",
          [
            "Good deeds must not replace employment, work shifts, or ordinary commercial services. Group good deeds must be voluntary, safe, and non-commercial. Partners may not direct assignments through groups or good deeds and are responsible only for benefits they offer."
          ]
        ],
        [
          "3. Submissions and Evidence",
          [
            "Submitters must provide truthful information, hold the necessary rights to uploaded files, and avoid unnecessary third-party personal data. Dangerous, unlawful, or manipulated activities are not rewarded. External evidence links are prohibited."
          ]
        ],
        [
          "4. Community Review and Appeals",
          [
            "The first assigned review fixes difficulty, complexity, and base experience points within the configured range. The experience points amount determines the number of independent reviews; high values also require an admin. The full quorum decides by majority. A tie triggers one additional review. Rejections may be appealed within the configured period."
          ]
        ],
        [
          "5. Group Good Deeds",
          [
            "Group admins may announce voluntary group good deeds. Members register themselves and confirm actual participation only after the activity starts. Organizers allocate total experience points among confirmed participants; no one may receive more than 50%. The community review reviews the allocation. Organizers remain responsible for permission, safety, and non-commercial execution."
          ]
        ],
        [
          "5a. Group points",
          [
            "Group points are non-purchasable, non-transferable and non-redeemable internal group progression points with no monetary value. They are generated in addition to player experience points from a configurable share of verified base experience points and may be used exclusively for internal group decorations and convenience features. They are not accepted by partners or outside Goodvale."
          ]
        ],
        [
          "6. Partner Offers",
          [
            "Partners configure unlocks based on rank, level, total experience points, category progress, or a verified system good deed. experience points are not consumed on redemption. Redemption requires a short-lived signed QR pass, and each QR session can be used only once. The partner is responsible for the benefit and its availability."
          ]
        ],
        [
          "7. Focus areas, Boosts, and Trust",
          [
            "Focus and benefit bonuses affect game values only. The experience bonus in the Food & Nutrition focus is free and available once per calendar week. Submission consumes the charge even if later rejected or withdrawn. Trust remains a separate trust and conduct value."
          ]
        ],
        [
          "8. Security and Enforcement",
          [
            "Reusing evidence, QR manipulation, deception, harassment, or circumvention may lead to rejection, restrictions, or suspension."
          ]
        ],
        [
          "9. Liability",
          [
            "Goodvale reviews platform evidence but does not guarantee on-site safety, permits, or fulfillment of partner offers. Mandatory statutory liability remains unaffected."
          ]
        ],
        [
          "10. Eligibility, Registration and Contract",
          [
            "Goodvale is for people aged 18 and over. By registering you confirm that you are an adult and accept these terms. The service contract begins when the account is activated; partner accounts require separate approval. Provide accurate information, protect your credentials and report suspected account misuse. Registration does not guarantee particular partner offers or rewards."
          ]
        ],
        [
          "11. Content Rights",
          [
            "Your content remains yours. You grant Goodvale only the non-exclusive rights necessary to store, technically process, display within your chosen audience and review it. Advertising use beyond this requires separate permission. Upload only content for which you have the necessary rights. Rights end on deletion except insofar as lawful retention or pending proceedings require them."
          ]
        ],
        [
          "12. Termination and Changes",
          [
            "You may stop using the service and delete your account in your profile or terminate by emailing thomas@truegler.io. Group leaders may first need to transfer leadership or dissolve the group; your right to terminate remains unaffected. Immediate suspension for serious cause, including significant unlawful activity or security threats, remains possible.",
            "Material changes to these terms will be clearly announced before taking effect. Where consent is required, we request it expressly; silence is not consent. You may terminate before changes take effect. Maintenance and development may affect availability and game rules; mandatory rights remain unaffected."
          ]
        ],
        [
          "13. Reporting Illegal Content",
          [
            "Users and authorities can contact thomas@truegler.io in German or English. For content reports, preferably use the subject “Content report” and provide the precise link or unique content identifier, reasons for suspected illegality and any supporting evidence. Include your name, email address and a statement that the information is accurate and complete to the best of your knowledge; statutory exceptions to identification requirements remain applicable.",
            "We acknowledge receipt, review reports diligently and impartially, and communicate our decision and available remedies where contact details are available. Do not send unnecessary sensitive data. This contact point is not an emergency service."
          ]
        ],
        [
          "14. Moderation and Complaints",
          [
            "Illegal content, threats, harassment, disclosure of private third-party data, rights infringements and manipulated evidence are prohibited. Depending on severity, repetition and risk, content may be restricted or removed, submissions rejected and accounts temporarily or permanently suspended. Automated checks assist detection and assignment; disputed measures receive human review.",
            "Where legally permitted, affected users receive understandable reasons covering the relevant circumstances, rule, scope, duration and complaint route. You may challenge moderation measures free of charge within six months by emailing thomas@truegler.io with the subject “Moderation complaint”, identifying the decision and your objections. An authorized person reviews the complaint, not solely an automated system. Incorrect measures are corrected. The in-app community review appeal procedure additionally applies to deed and experience points decisions. Statutory judicial and out-of-court remedies remain unaffected."
          ]
        ],
        [
          "15. Applicable Law",
          [
            "Austrian law applies. Mandatory consumer protections in your country of habitual residence remain applicable where required by law. Statutory jurisdiction is not restricted."
          ]
        ]
      ],
      [
        [
          "1. Controller",
          [
            "The controller is the operator named in the legal notice. Privacy requests: thomas@truegler.io."
          ]
        ],
        [
          "2. Data and Purposes",
          [
            "We process account and profile data, progress, trust, group membership, Group points ledger entries and unlocks, submissions, community review decisions, appeals, partner redemptions, messages, push subscriptions, and security/access logs. Purposes include account administration, gameplay, abuse prevention, communication, and evidence review."
          ]
        ],
        [
          "3. Legal Bases",
          [
            "Account administration, communication, submission reviews and benefit redemption rely on Article 6(1)(b) GDPR insofar as necessary for those services. Optional Umami statistics and Sentry browser diagnostics each require separate consent under Article 6(1)(a). Security logs, server diagnostics and abuse prevention serve our legitimate interests in safe and fair operation under Article 6(1)(f). Statutory retention and disclosure duties rely on Article 6(1)(c).",
            "An email address, credentials and the information required for your role are necessary to provide an account. Optional information and tracking consent are not required for general use. Consent may be withdrawn prospectively at any time without affecting the lawfulness of prior processing."
          ]
        ],
        [
          "4. Evidence Privacy",
          [
            "Evidence you choose to submit is processed to perform the review you request (Article 6(1)(b) GDPR). The upload confirmation acknowledges the evidence rules; it is not blanket consent to arbitrary processing. Files are encrypted outside public web directories and accessible to the submitter, assigned reviewers and authorized administrators. Access is logged.",
            "Upload only necessary evidence. Obscure uninvolved people, number plates and private addresses. Do not upload health records, identity documents or other sensitive information about yourself or others. Confirming the upload does not establish rights or a lawful basis for third-party data.",
            "Direct deletion of individual evidence is restricted once review starts to preserve the integrity of the proceedings. You may still request erasure, restriction or withdrawal of your submission at thomas@truegler.io. Requests are assessed individually; continued retention requires a valid legal basis, such as necessary legal defence. The technical restriction does not override statutory rights."
          ]
        ],
        [
          "5. Recipients and Processors",
          [
            "Data is disclosed only to technically or operationally necessary recipients, such as contracted hosting, push, or security providers. Partners see only data needed to verify eligibility and redemption."
          ]
        ],
        [
          "5a. Hetzner – Hosting",
          [
            "We use Hetzner Online GmbH for the hosting infrastructure of Goodvale. This involves processing data stored to operate the platform and technical connection and access data, including IP addresses, timestamps, and requested resources. This supports platform availability and security on the basis of contract performance and our legitimate interests in secure operation."
          ],
          "https://www.hetzner.com/legal/privacy-policy/"
        ],
        [
          "5b. Sentry – Error Diagnostics",
          [
            "Sentry helps detect and resolve technical errors. Processing may include error messages, stack traces, technical browser, device and request data, and performance data. Browser error reporting is enabled only with your consent, which you can withdraw through the tracking settings. Automatic transmission of additional personal data is disabled in the browser. Server-side error and performance diagnostics operate separately on the basis of our legitimate interests in maintaining a secure and reliable service."
          ],
          "https://sentry.io/privacy/"
        ],
        [
          "5c. Umami – Usage Statistics",
          [
            "With your consent, Umami collects page views and technical usage data, such as visited URLs, referrers, and browser and device information. We use these statistics to understand and improve the use and usability of Goodvale. You can disable collection at any time in the tracking settings. Processing takes place through the Umami instance configured for Goodvale."
          ],
          "https://docs.umami.is/"
        ],
        [
          "5d. Firebase – Push Notifications",
          [
            "We use Google Firebase Cloud Messaging for Android push notifications. This involves device registration tokens, technical delivery data, and notification data. Goodvale sends a generic new-notification message plus a type and reference identifier, rather than chat message text. Delivery follows activation and device permission. You can disable push notifications in your device settings."
          ],
          "https://firebase.google.com/support/privacy"
        ],
        [
          "5e. Resend – Email Delivery",
          [
            "Resend delivers transactional account emails, including email verification and password resets. Processing includes the recipient address, email contents including verification or reset links, and technical sending and delivery data. This supports account administration and security on the basis of contract performance and our legitimate interests in protecting user accounts."
          ],
          "https://resend.com/legal/privacy-policy"
        ],
        [
          "5f. Maps and Location",
          [
            "Maps load tiles from the OpenStreetMap Foundation. Opening a map sends your IP address, technical request data and the requested map area to its servers to display the requested map and support our legitimate interest in functional location features. The map area may indicate the location being viewed.",
            "Device location sharing is optional and requires device permission. Manually entered locations, public group or partner locations and optional GPS evidence are processed for the relevant feature. Publicly entered locations are visible to others; GPS evidence forms part of a protected submission."
          ],
          "https://osmfoundation.org/wiki/Privacy_Policy"
        ],
        [
          "5g. Apple Push on iOS",
          [
            "iOS notifications use Apple Push Notification service (APNs), processing device tokens, technical delivery data, a generic notification and its type and reference identifier. This requires activation and device permission, which you may revoke in device settings."
          ],
          "https://www.apple.com/legal/privacy/"
        ],
        [
          "5h. Visibility and Recipients within Goodvale",
          [
            "Public profile details such as username, selected profile image, biography and displayed progress may be shown to other users or visitors. Do not publish confidential details there. Group content is visible according to its public or members-only feature. Direct messages are intended for conversation participants and group chats for members. Authorized administrators may access data where necessary for operation, support or investigation of specific abuse reports.",
            "Community Review reviewers access protected evidence only as part of an assignment. Partners receive the eligibility and redemption information required for a benefit. Submitting information for review does not by itself make it public."
          ]
        ],
        [
          "5i. Regions and International Transfers",
          [
            "Hetzner hosting and our self-hosted Umami instance are located in Europe. For external services we use available, configured EU data regions. EU storage does not automatically exclude access or processing outside the EEA by international providers or subprocessors, particularly for global push and email services.",
            "Transfers outside the EEA require an adequacy decision under Article 45 GDPR or appropriate safeguards under Article 46, such as EU Standard Contractual Clauses and supplementary measures where necessary. EU-US Data Privacy Framework certification can be relied upon only where the specific recipient and processing are covered. For information on the recipients and safeguards applicable to your data and copies of safeguards, contact thomas@truegler.io."
          ]
        ],
        [
          "6. Retention",
          [
            "Account data is stored for the life of the account. Account deletion removes or clears contact details, profile content, locations, evidence, push registrations, associated direct messages and your group chat messages. Pending submissions are withdrawn. Pseudonymized review and ledger records may remain and are still personal data where attribution is possible.",
            "The system provides a standard evidence retention period of 90 days after the final decision, at least until seven days after the applicable appeal period ends. Pending proceedings and appeals must be taken into account. Any necessary deviation requires a specific procedural purpose or legal basis.",
            "Security, diagnostic, delivery and review logs are retained according to the need to resolve errors, establish delivery, investigate a specific abuse incident or defend claims. Personal data no longer needed must be erased or genuinely anonymized; closed cases do not justify indefinite retention. Statutory retention duties apply where relevant. Local preferences remain until changed or browser storage is cleared."
          ]
        ],
        [
          "7. Your Rights",
          [
            "You can download a machine-readable copy in your profile and anonymize your account. Where legally applicable, you also have rights of access, rectification, erasure, restriction, portability, objection, and complaint to the Austrian Data Protection Authority."
          ]
        ],
        [
          "8. Account Anonymization",
          [
            "Self-service deletion removes contact data and evidence files and disables access. Review, ledger, and security records may remain pseudonymized where required for system integrity or legal obligations."
          ]
        ],
        [
          "9. Rights, Objections and Contact",
          [
            "Contact thomas@truegler.io or the postal address in the legal notice to request access, rectification, erasure, restriction, portability or withdrawal of consent. You may object to processing based on legitimate interests on grounds relating to your particular situation. We generally respond within one month and explain any legally permitted extension. You may complain to the Austrian Data Protection Authority."
          ],
          "https://dsb.gv.at/"
        ],
        [
          "10. Local Storage and Automated Rules",
          [
            "Local browser storage supports login, language, appearance and privacy choices. Optional Umami statistics and Sentry browser diagnostics are separately selectable and disabled by default. Refusal does not affect general use. Change your choices using the settings below.",
            "experience points, unlocks, trust effects and anti-cheat checks are partly calculated by rules affecting game progress and review assignments. Assigned people make community review decisions. Disputed results may be referred for human review using the appeal feature or thomas@truegler.io."
          ]
        ]
      ]
    ]
  },
  "classAvailability": {
    "bonus": "Experience bonus"
  }
}
